const ZenProperties = {};

ZenProperties["INST_CMN_WMT"] = {
  "name": "INST_CMN_WMT",
  "description": "WMT",
  "byteLength": 28,
  "parameters": {
    "SW": {
      "id": "SW",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Wave Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "WAV_GTYPE": {
      "id": "WAV_GTYPE",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "Wave Group Type",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "INT",
        "1": "EXP",
        "2": "SAMP"
      }
    },
    "WAV_GID": {
      "id": "WAV_GID",
      "byteOffset": 2,
      "byteLength": 2,
      "description": "Wave Group ID",
      "dataRange": [
        0,
        16383
      ],
      "initValue": 0
    },
    "WAV_NUM_L": {
      "id": "WAV_NUM_L",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "Wave Number L",
      "dataRange": [
        0,
        16383
      ],
      "initValue": 0
    },
    "WAV_NUM_R": {
      "id": "WAV_NUM_R",
      "byteOffset": 6,
      "byteLength": 2,
      "description": "Wave Number R",
      "dataRange": [
        0,
        16383
      ],
      "initValue": 0
    },
    "WAV_GAIN": {
      "id": "WAV_GAIN",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "Wave Gain",
      "dataRange": [
        0,
        5
      ],
      "initValue": 3,
      "displayMeasurement": "dB",
      "values": {
        "0": "-18",
        "1": "-12",
        "2": "-6",
        "3": "0",
        "4": "+6",
        "5": "+12"
      }
    },
    "FXM_SW": {
      "id": "FXM_SW",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "Wave FXM Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "FXM_COLOR": {
      "id": "FXM_COLOR",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "Wave FXM Color",
      "dataRange": [
        1,
        4
      ],
      "initValue": 1
    },
    "FXM_DEPTH": {
      "id": "FXM_DEPTH",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "Wave FXM Depth",
      "dataRange": [
        0,
        16
      ],
      "initValue": 0
    },
    "PIT_CRS": {
      "id": "PIT_CRS",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "Wave Coarse Tune",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0
    },
    "PIT_FINE": {
      "id": "PIT_FINE",
      "byteOffset": 13,
      "byteLength": 1,
      "description": "Wave Fine Tune",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "PAN": {
      "id": "PAN",
      "byteOffset": 14,
      "byteLength": 1,
      "description": "Wave Pan",
      "dataRange": [
        -64,
        63
      ],
      "initValue": 0
    },
    "PAN_RND_SW": {
      "id": "PAN_RND_SW",
      "byteOffset": 15,
      "byteLength": 1,
      "description": "Wave Random Pan Sw",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PAN_ALT_SW": {
      "id": "PAN_ALT_SW",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "Wave Alternate Pan Sw",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON",
        "2": "REVERSE"
      }
    },
    "LEVEL": {
      "id": "LEVEL",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "Wave Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 18,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "DELAY_MODE": {
      "id": "DELAY_MODE",
      "byteOffset": 19,
      "byteLength": 1,
      "description": "Delay Mode",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "NORMAL",
        "1": "HOLD",
        "2": "KEYOFF-NORMAL",
        "3": "KEYOFF-DECAY"
      }
    },
    "DLY_TIME_SYNC": {
      "id": "DLY_TIME_SYNC",
      "byteOffset": 20,
      "byteLength": 1,
      "description": "DelayTime Sync",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "DLY_TIME_NOTE": {
      "id": "DLY_TIME_NOTE",
      "byteOffset": 21,
      "byteLength": 1,
      "description": "DelayTime (note)",
      "dataRange": [
        0,
        21
      ],
      "initValue": 12,
      "values": {
        "0": "1/64T",
        "1": "1/64",
        "2": "1/32T",
        "3": "1/32",
        "4": "1/16T",
        "5": "1/32.",
        "6": "1/16",
        "7": "1/8T",
        "8": "1/16.",
        "9": "1/8",
        "10": "1/4T",
        "11": "1/8.",
        "12": "1/4",
        "13": "1/2T",
        "14": "1/4.",
        "15": "1/2",
        "16": "1T",
        "17": "1/2.",
        "18": "1",
        "19": "2T",
        "20": "1.",
        "21": "2"
      }
    },
    "DLY_TIME": {
      "id": "DLY_TIME",
      "byteOffset": 22,
      "byteLength": 2,
      "description": "DelayTime",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "VRANGE_LO": {
      "id": "VRANGE_LO",
      "byteOffset": 24,
      "byteLength": 1,
      "description": "VeloRange Lower",
      "dataRange": [
        1,
        127
      ],
      "initValue": 1
    },
    "VRANGE_UP": {
      "id": "VRANGE_UP",
      "byteOffset": 25,
      "byteLength": 1,
      "description": "VeloRange Upper",
      "dataRange": [
        1,
        127
      ],
      "initValue": 127
    },
    "VFADE_LO": {
      "id": "VFADE_LO",
      "byteOffset": 26,
      "byteLength": 1,
      "description": "VeloFade Lower",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "VFADE_UP": {
      "id": "VFADE_UP",
      "byteOffset": 27,
      "byteLength": 1,
      "description": "VeloFade Upper",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["INST_CMN"] = {
  "name": "INST_CMN",
  "description": "PCMRhythm Inst Common",
  "byteLength": 152,
  "parameters": {
    "NAME_1": {
      "id": "NAME_1",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Name 1",
      "dataRange": [
        32,
        127
      ],
      "initValue": 32,
      "displayMeasurement": "ASCII"
    },
    "CATEGORY": {
      "id": "CATEGORY",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "Category",
      "dataRange": [
        0,
        21
      ],
      "initValue": 0
    },
    "LEVEL": {
      "id": "LEVEL",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "SRC_KEY": {
      "id": "SRC_KEY",
      "byteOffset": 18,
      "byteLength": 1,
      "description": "Source Key",
      "dataRange": [
        0,
        127
      ],
      "initValue": 60
    },
    "PIT_FINE": {
      "id": "PIT_FINE",
      "byteOffset": 19,
      "byteLength": 1,
      "description": "Fine Tune",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0,
      "displayMeasurement": "cent"
    },
    "PIT_RND": {
      "id": "PIT_RND",
      "byteOffset": 20,
      "byteLength": 2,
      "description": "Random Pitch Depth",
      "dataRange": [
        0,
        1200
      ],
      "initValue": 0,
      "displayMeasurement": "cent"
    },
    "PAN_RND": {
      "id": "PAN_RND",
      "byteOffset": 22,
      "byteLength": 1,
      "description": "Random Pan Depth",
      "dataRange": [
        0,
        63
      ],
      "initValue": 0
    },
    "PAN_ALT": {
      "id": "PAN_ALT",
      "byteOffset": 23,
      "byteLength": 1,
      "description": "Alternate Pan Depth",
      "dataRange": [
        -64,
        63
      ],
      "initValue": 0
    },
    "ASGN_TYPE": {
      "id": "ASGN_TYPE",
      "byteOffset": 24,
      "byteLength": 1,
      "description": "Assign Type",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "MULTI",
        "1": "SINGLE"
      }
    },
    "ENV_MODE": {
      "id": "ENV_MODE",
      "byteOffset": 25,
      "byteLength": 1,
      "description": "Envelope Mode",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "NO-SUS",
        "1": "SUSTAIN"
      }
    },
    "WMT_VEL_CTRL": {
      "id": "WMT_VEL_CTRL",
      "byteOffset": 26,
      "byteLength": 1,
      "description": "WMT Velocity Control",
      "dataRange": [
        0,
        2
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "ON",
        "2": "RANDOM"
      }
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 27,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "WMT": {
      "id": "WMT",
      "byteOffset": 28,
      "byteLength": 112,
      "description": "WMT",
      "blockName": "INST_CMN_WMT",
      "count": 4,
      "blockByteLength": 28,
      "block": ZenProperties["INST_CMN_WMT"]
    },
    "FILTER_TYPE": {
      "id": "FILTER_TYPE",
      "byteOffset": 140,
      "byteLength": 1,
      "description": "TVF Filter Type",
      "dataRange": [
        0,
        6
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "LPF",
        "2": "BPF",
        "3": "HPF",
        "4": "PKG",
        "5": "LPF2",
        "6": "LPF3"
      }
    },
    "PADDING2": {
      "id": "PADDING2",
      "byteOffset": 141,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "CUTOFF": {
      "id": "CUTOFF",
      "byteOffset": 142,
      "byteLength": 2,
      "description": "TVF Cutoff Frequency",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    },
    "CUTOFF_VCRV": {
      "id": "CUTOFF_VCRV",
      "byteOffset": 144,
      "byteLength": 1,
      "description": "TVF Cutoff Velocity Curve",
      "dataRange": [
        0,
        7
      ],
      "initValue": 1,
      "values": {
        "0": "FIXED",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7"
      }
    },
    "CUTOFF_VSENS": {
      "id": "CUTOFF_VSENS",
      "byteOffset": 145,
      "byteLength": 1,
      "description": "TVF Cutoff Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "RESO": {
      "id": "RESO",
      "byteOffset": 146,
      "byteLength": 2,
      "description": "TVF Resonance",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "RESO_VSENS": {
      "id": "RESO_VSENS",
      "byteOffset": 148,
      "byteLength": 1,
      "description": "TVF Resonance Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "LEVEL_VCRV": {
      "id": "LEVEL_VCRV",
      "byteOffset": 149,
      "byteLength": 1,
      "description": "TVA Level Velocity Curve",
      "dataRange": [
        0,
        7
      ],
      "initValue": 1,
      "values": {
        "0": "FIXED",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7"
      }
    },
    "LEVEL_VSENS": {
      "id": "LEVEL_VSENS",
      "byteOffset": 150,
      "byteLength": 1,
      "description": "TVA Level Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "TEMPO_SYNC": {
      "id": "TEMPO_SYNC",
      "byteOffset": 151,
      "byteLength": 1,
      "description": "Wave Tempo Sync",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MDLCORE"] = {
  "name": "MDLCORE",
  "description": "Model Core Parameter",
  "byteLength": 112,
  "parameters": {
    "MODEL": {
      "id": "MODEL",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Model",
      "dataRange": [
        0,
        5
      ],
      "initValue": 0,
      "values": {
        "0": "---",
        "1": "JP8",
        "2": "JX8P",
        "3": "JUNO106",
        "4": "SH101",
        "5": "JUNO60"
      }
    },
    "LFOWAVE": {
      "id": "LFOWAVE",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "LFO WAVE FORM",
      "dataRange": [
        0,
        10
      ],
      "initValue": 0,
      "values": {
        "0": "SIN",
        "1": "TRI",
        "2": "SAW-UP",
        "3": "SAW-DW",
        "4": "SQR",
        "5": "RND",
        "6": "TRP",
        "7": "S&H",
        "8": "CHS",
        "9": "VSIN",
        "10": "STEP"
      }
    },
    "LFORATE": {
      "id": "LFORATE",
      "byteOffset": 2,
      "byteLength": 2,
      "description": "LFO RATE",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "LFODLY": {
      "id": "LFODLY",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "LFO DELAY TIME",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "OSC1MOD": {
      "id": "OSC1MOD",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "OSC1 MOD",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC1PENV": {
      "id": "OSC1PENV",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "OSC1 PITCH ENV DEPTH",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC1DEST": {
      "id": "OSC1DEST",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "OSC1 DEST SELECT",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "OSC1",
        "1": "BOTH",
        "2": "OSC2"
      }
    },
    "OSC1ENVS": {
      "id": "OSC1ENVS",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "OSC1 ENVT SELECT",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "1",
        "1": "2"
      }
    },
    "OSC1WAVE": {
      "id": "OSC1WAVE",
      "byteOffset": 10,
      "byteLength": 2,
      "description": "OSC1 WAVE FORM",
      "dataRange": [
        0,
        27
      ],
      "initValue": 0,
      "values": {
        "0": "PW",
        "1": "SAW",
        "2": "SUB1OCT1",
        "3": "SUB2OCT1",
        "4": "SUB2OCT2",
        "5": "NOISE",
        "6": "PW",
        "7": "SAW",
        "8": "SUB1OCT1",
        "9": "NOISE",
        "10": "SIN",
        "11": "TRI",
        "12": "SAW",
        "13": "PW",
        "14": "SQR",
        "15": "NOISE",
        "16": "SAW",
        "17": "PULSE",
        "18": "SQR",
        "19": "NOISE",
        "20": "TRI",
        "21": "SAW+TRI",
        "22": "SAW",
        "23": "SQR",
        "24": "SQR2",
        "25": "SQR3",
        "26": "WHITE NOISE",
        "27": "PINK NOISE"
      }
    },
    "OSC1FEET": {
      "id": "OSC1FEET",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "OSC1 FEET",
      "dataRange": [
        0,
        4
      ],
      "initValue": 0,
      "values": {
        "0": "32'",
        "1": "16'",
        "2": "8'",
        "3": "4'",
        "4": "2'"
      }
    },
    "OSC1COARSE": {
      "id": "OSC1COARSE",
      "byteOffset": 13,
      "byteLength": 1,
      "description": "OSC1 COARSE TUNE",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0
    },
    "OSC1FINE": {
      "id": "OSC1FINE",
      "byteOffset": 14,
      "byteLength": 1,
      "description": "OSC1 FINE TUNE",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "OSC1LOWFREQ": {
      "id": "OSC1LOWFREQ",
      "byteOffset": 15,
      "byteLength": 1,
      "description": "OSC1 LOW FREQ PITCH",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "OSC1MODE": {
      "id": "OSC1MODE",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "OSC1 MODE",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "NORMAL",
        "1": "LOW FREQ"
      }
    },
    "OSC1PWM": {
      "id": "OSC1PWM",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "OSC1 PWM DEPTH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "OSC1PLSW": {
      "id": "OSC1PLSW",
      "byteOffset": 18,
      "byteLength": 1,
      "description": "OSC1 PULSE WIDTH",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "OSC1PLSM": {
      "id": "OSC1PLSM",
      "byteOffset": 19,
      "byteLength": 1,
      "description": "OSC1 PULSE WIDTH MODE",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "LFO",
        "1": "MANUAL",
        "2": "ENV"
      }
    },
    "OSC2MOD": {
      "id": "OSC2MOD",
      "byteOffset": 20,
      "byteLength": 1,
      "description": "OSC2 MOD",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC2PENV": {
      "id": "OSC2PENV",
      "byteOffset": 21,
      "byteLength": 1,
      "description": "OSC2 PITCH ENV DEPTH",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC2WAVE": {
      "id": "OSC2WAVE",
      "byteOffset": 22,
      "byteLength": 2,
      "description": "OSC2 WAVE FORM",
      "dataRange": [
        0,
        27
      ],
      "initValue": 0,
      "values": {
        "0": "PW",
        "1": "SAW",
        "2": "SUB1OCT1",
        "3": "SUB2OCT1",
        "4": "SUB2OCT2",
        "5": "NOISE",
        "6": "PW",
        "7": "SAW",
        "8": "SUB1OCT1",
        "9": "NOISE",
        "10": "SIN",
        "11": "TRI",
        "12": "SAW",
        "13": "PW",
        "14": "SQR",
        "15": "NOISE",
        "16": "SAW",
        "17": "PULSE",
        "18": "SQR",
        "19": "NOISE",
        "20": "TRI",
        "21": "SAW+TRI",
        "22": "SAW",
        "23": "SQR",
        "24": "SQR2",
        "25": "SQR3",
        "26": "WHITE NOISE",
        "27": "PINK NOISE"
      }
    },
    "OSC2FEET": {
      "id": "OSC2FEET",
      "byteOffset": 24,
      "byteLength": 1,
      "description": "OSC2 FEET",
      "dataRange": [
        0,
        4
      ],
      "initValue": 0,
      "values": {
        "0": "32'",
        "1": "16'",
        "2": "8'",
        "3": "4'",
        "4": "2'"
      }
    },
    "OSC2COARSE": {
      "id": "OSC2COARSE",
      "byteOffset": 25,
      "byteLength": 1,
      "description": "OSC2 COARSE TUNE",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0
    },
    "OSC2FINE": {
      "id": "OSC2FINE",
      "byteOffset": 26,
      "byteLength": 1,
      "description": "OSC2 FINE TUNE",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "OSC2LOWFREQ": {
      "id": "OSC2LOWFREQ",
      "byteOffset": 27,
      "byteLength": 1,
      "description": "OSC2 LOW FREQ PITCH",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "OSC2MODE": {
      "id": "OSC2MODE",
      "byteOffset": 28,
      "byteLength": 1,
      "description": "OSC2 MODE",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "NORMAL",
        "1": "LO FREQ"
      }
    },
    "OSC2PW": {
      "id": "OSC2PW",
      "byteOffset": 29,
      "byteLength": 1,
      "description": "OSC2 PULSE WIDTH",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "OSC3MOD": {
      "id": "OSC3MOD",
      "byteOffset": 30,
      "byteLength": 1,
      "description": "OSC3 MOD",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC3PENV": {
      "id": "OSC3PENV",
      "byteOffset": 31,
      "byteLength": 1,
      "description": "OSC3 PITCH ENV DEPTH",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC3WAVE": {
      "id": "OSC3WAVE",
      "byteOffset": 32,
      "byteLength": 2,
      "description": "OSC3 WAVE FORM",
      "dataRange": [
        0,
        27
      ],
      "initValue": 0,
      "values": {
        "0": "PW",
        "1": "SAW",
        "2": "SQR 1OCT",
        "3": "SQR 2OCT",
        "4": "SH SubOSC",
        "5": "NOISE",
        "6": "PW",
        "7": "SAW",
        "8": "SQR 1OCT",
        "9": "NOISE",
        "10": "SIN",
        "11": "TRI",
        "12": "SAW",
        "13": "PW",
        "14": "SQR",
        "15": "NOISE",
        "16": "SAW",
        "17": "PULSE",
        "18": "SQR",
        "19": "NOISE",
        "20": "TRI",
        "21": "SAW+TRI",
        "22": "SAW",
        "23": "SQR",
        "24": "SQR2",
        "25": "SQR3",
        "26": "WHITE NOISE",
        "27": "PINK NOISE"
      }
    },
    "OSC3FEET": {
      "id": "OSC3FEET",
      "byteOffset": 34,
      "byteLength": 1,
      "description": "OSC3 FEET",
      "dataRange": [
        0,
        4
      ],
      "initValue": 0,
      "values": {
        "0": "32'",
        "1": "16'",
        "2": "8'",
        "3": "4'",
        "4": "2'"
      }
    },
    "OSC3COARSE": {
      "id": "OSC3COARSE",
      "byteOffset": 35,
      "byteLength": 1,
      "description": "OSC3 COARSE TUNE",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0
    },
    "OSC3FINE": {
      "id": "OSC3FINE",
      "byteOffset": 36,
      "byteLength": 1,
      "description": "OSC3 FINE TUNE",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "OSC3LOWFREQ": {
      "id": "OSC3LOWFREQ",
      "byteOffset": 37,
      "byteLength": 1,
      "description": "OSC3 LOW FREQ PITCH",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "OSC3MODE": {
      "id": "OSC3MODE",
      "byteOffset": 38,
      "byteLength": 1,
      "description": "OSC3 MODE",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "NORMAL",
        "1": "LO FREQ"
      }
    },
    "NOISE": {
      "id": "NOISE",
      "byteOffset": 39,
      "byteLength": 1,
      "description": "NOISE",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "WHITE",
        "1": "PINK"
      }
    },
    "MODDPTH": {
      "id": "MODDPTH",
      "byteOffset": 40,
      "byteLength": 2,
      "description": "MOD DEPTH",
      "dataRange": [
        0,
        10800
      ],
      "initValue": 0
    },
    "MODMODE": {
      "id": "MODMODE",
      "byteOffset": 42,
      "byteLength": 1,
      "description": "MOD MODE",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "SYNC",
        "2": "RING",
        "3": "X-MOD"
      }
    },
    "MXROSC1": {
      "id": "MXROSC1",
      "byteOffset": 43,
      "byteLength": 1,
      "description": "OSC1 LEVEL",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "MXROSC2": {
      "id": "MXROSC2",
      "byteOffset": 44,
      "byteLength": 1,
      "description": "OSC2 LEVEL",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "MXROSC3": {
      "id": "MXROSC3",
      "byteOffset": 45,
      "byteLength": 1,
      "description": "OSC3 LEVEL",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "MXRNOISE": {
      "id": "MXRNOISE",
      "byteOffset": 46,
      "byteLength": 1,
      "description": "NOISE LEVEL",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "MXRENVD": {
      "id": "MXRENVD",
      "byteOffset": 47,
      "byteLength": 1,
      "description": "MIXER ENV DEPTH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "MXRENVS": {
      "id": "MXRENVS",
      "byteOffset": 48,
      "byteLength": 1,
      "description": "MIXER ENV SELECT",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "1",
        "1": "2"
      }
    },
    "MXRDYNA": {
      "id": "MXRDYNA",
      "byteOffset": 49,
      "byteLength": 1,
      "description": "MIXER DYNAMICS",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "FLTTYPE": {
      "id": "FLTTYPE",
      "byteOffset": 50,
      "byteLength": 1,
      "description": "FILTER TYPE",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "FLTHPF2": {
      "id": "FLTHPF2",
      "byteOffset": 51,
      "byteLength": 1,
      "description": "FILTER HPF STEP",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "FLTHPF1": {
      "id": "FLTHPF1",
      "byteOffset": 52,
      "byteLength": 2,
      "description": "FILTER HPF",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "FLTFREQ": {
      "id": "FLTFREQ",
      "byteOffset": 54,
      "byteLength": 2,
      "description": "FILTER FREQ",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "FLTRESO": {
      "id": "FLTRESO",
      "byteOffset": 56,
      "byteLength": 2,
      "description": "FILTER RESO",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "FLTENVD": {
      "id": "FLTENVD",
      "byteOffset": 58,
      "byteLength": 2,
      "description": "FILTER ENV DEPTH",
      "dataRange": [
        -1023,
        1023
      ],
      "initValue": 0
    },
    "FLTENVS": {
      "id": "FLTENVS",
      "byteOffset": 60,
      "byteLength": 1,
      "description": "FILTER ENV SELECT",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "1",
        "1": "2"
      }
    },
    "FLTSLOPE": {
      "id": "FLTSLOPE",
      "byteOffset": 61,
      "byteLength": 1,
      "description": "FILTER SLOPE",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "-12dB",
        "1": "-18db",
        "2": "-24dB"
      }
    },
    "FLTKYBD": {
      "id": "FLTKYBD",
      "byteOffset": 62,
      "byteLength": 2,
      "description": "FILTER KEY FOLLOW",
      "dataRange": [
        -200,
        200
      ],
      "initValue": 0
    },
    "FLTMOD": {
      "id": "FLTMOD",
      "byteOffset": 64,
      "byteLength": 1,
      "description": "FILTER MOD",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 65,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "AMPLVL": {
      "id": "AMPLVL",
      "byteOffset": 66,
      "byteLength": 1,
      "description": "AMP LEVEL",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "AMPMOD1": {
      "id": "AMPMOD1",
      "byteOffset": 67,
      "byteLength": 1,
      "description": "AMP MOD",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "AMPMOD2": {
      "id": "AMPMOD2",
      "byteOffset": 68,
      "byteLength": 1,
      "description": "AMP MOD STEP",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "AMPENVS": {
      "id": "AMPENVS",
      "byteOffset": 69,
      "byteLength": 1,
      "description": "AMP ENV SELECT",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "ENV F&A",
        "1": "ENV2",
        "2": "G-AMP",
        "3": "G-ENV2"
      }
    },
    "ENV1A": {
      "id": "ENV1A",
      "byteOffset": 70,
      "byteLength": 2,
      "description": "ENV1 ATTACK",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV1D": {
      "id": "ENV1D",
      "byteOffset": 72,
      "byteLength": 2,
      "description": "ENV1 DECAY",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV1S": {
      "id": "ENV1S",
      "byteOffset": 74,
      "byteLength": 2,
      "description": "ENV1 SUSTAIN",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV1R": {
      "id": "ENV1R",
      "byteOffset": 76,
      "byteLength": 2,
      "description": "ENV1 RELEASE",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV1KYBD1": {
      "id": "ENV1KYBD1",
      "byteOffset": 78,
      "byteLength": 1,
      "description": "ENV1 KEY FOLLOW",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "ENV1KYBD2": {
      "id": "ENV1KYBD2",
      "byteOffset": 79,
      "byteLength": 1,
      "description": "ENV1 KEY FOLLOW STEP",
      "dataRange": [
        0,
        6
      ],
      "initValue": 0
    },
    "ENV2A": {
      "id": "ENV2A",
      "byteOffset": 80,
      "byteLength": 2,
      "description": "ENV2 ATTACK",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV2D": {
      "id": "ENV2D",
      "byteOffset": 82,
      "byteLength": 2,
      "description": "ENV2 DECAY",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV2S": {
      "id": "ENV2S",
      "byteOffset": 84,
      "byteLength": 2,
      "description": "ENV2 SUSTAIN",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV2R": {
      "id": "ENV2R",
      "byteOffset": 86,
      "byteLength": 2,
      "description": "ENV2 RELEASE",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV2MODE": {
      "id": "ENV2MODE",
      "byteOffset": 88,
      "byteLength": 1,
      "description": "ENV2 MODE",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "GATE+TRIG",
        "1": "GATE",
        "2": "LFO"
      }
    },
    "ENV2KYBD1": {
      "id": "ENV2KYBD1",
      "byteOffset": 89,
      "byteLength": 1,
      "description": "ENV2 KEY FOLLOW",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "ENV2KYBD2": {
      "id": "ENV2KYBD2",
      "byteOffset": 90,
      "byteLength": 1,
      "description": "ENV2 KEY FOLLOW STEP",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "DYNPTCH": {
      "id": "DYNPTCH",
      "byteOffset": 91,
      "byteLength": 1,
      "description": "DYNAMICS PITCH",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "DYNFLTT": {
      "id": "DYNFLTT",
      "byteOffset": 92,
      "byteLength": 1,
      "description": "DYNAMICS FILTER",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "DYNAMP": {
      "id": "DYNAMP",
      "byteOffset": 93,
      "byteLength": 1,
      "description": "DYNAMICS AMP",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "PCHDRFT": {
      "id": "PCHDRFT",
      "byteOffset": 94,
      "byteLength": 1,
      "description": "PITCH DRIFT",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "BNDPTCH2": {
      "id": "BNDPTCH2",
      "byteOffset": 95,
      "byteLength": 1,
      "description": "BENDER PITCH DEPTH STEP",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "2",
        "1": "3",
        "2": "4",
        "3": "7"
      }
    },
    "BNDFLT": {
      "id": "BNDFLT",
      "byteOffset": 96,
      "byteLength": 1,
      "description": "BENDER FILTER DEPTH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "BNDLFO": {
      "id": "BNDLFO",
      "byteOffset": 97,
      "byteLength": 1,
      "description": "MODULATION LFO DEPTH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "BNDPTCH1": {
      "id": "BNDPTCH1",
      "byteOffset": 98,
      "byteLength": 2,
      "description": "BENDER PITCH DEPTH",
      "dataRange": [
        0,
        4800
      ],
      "initValue": 0
    },
    "PTATIME": {
      "id": "PTATIME",
      "byteOffset": 100,
      "byteLength": 2,
      "description": "PORTAMENT TIME",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "PTAMODE": {
      "id": "PTAMODE",
      "byteOffset": 102,
      "byteLength": 1,
      "description": "PORTAMENT MODE",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON",
        "2": "AUTO"
      }
    },
    "KBDMODE": {
      "id": "KBDMODE",
      "byteOffset": 103,
      "byteLength": 1,
      "description": "KEY MODE",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "POLY",
        "1": "SOLO",
        "2": "UNISON",
        "3": "SL-UNISON"
      }
    },
    "EXPAND": {
      "id": "EXPAND",
      "byteOffset": 104,
      "byteLength": 1,
      "description": "PARAMETER EXPANSION SWITCH",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "CONDITION": {
      "id": "CONDITION",
      "byteOffset": 105,
      "byteLength": 1,
      "description": "CONDITION",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "PTACRV": {
      "id": "PTACRV",
      "byteOffset": 106,
      "byteLength": 1,
      "description": "PORTAMENT CURVE TYPE",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "ORIGINAL",
        "1": "LINER",
        "2": "EXP1",
        "3": "EXP2"
      }
    },
    "AFT_LFO": {
      "id": "AFT_LFO",
      "byteOffset": 107,
      "byteLength": 1,
      "description": "AFTER TOUCH SENS LFO",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "AFT_FREQ": {
      "id": "AFT_FREQ",
      "byteOffset": 108,
      "byteLength": 1,
      "description": "AFTER TOUCH SENS FREQ",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "AFT_LEV": {
      "id": "AFT_LEV",
      "byteOffset": 109,
      "byteLength": 1,
      "description": "AFTER TOUCH SENS LEVEL",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "PADDING2": {
      "id": "PADDING2",
      "byteOffset": 110,
      "byteLength": 2,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MDLJD800COM"] = {
  "name": "MDLJD800COM",
  "description": "JD-800 Model Common",
  "byteLength": 44,
  "parameters": {
    "LEVEL": {
      "id": "LEVEL",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Level",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "KEYA_RNG_LO": {
      "id": "KEYA_RNG_LO",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "Key Range A Low",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "KEYA_RNG_HI": {
      "id": "KEYA_RNG_HI",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "Key Range A High",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "KEYB_RNG_LO": {
      "id": "KEYB_RNG_LO",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "Key Range B Low",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "KEYB_RNG_HI": {
      "id": "KEYB_RNG_HI",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "Key Range B High",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "KEYC_RNG_LO": {
      "id": "KEYC_RNG_LO",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "Key Range C Low",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "KEYC_RNG_HI": {
      "id": "KEYC_RNG_HI",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "Key Range C High",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "KEYD_RNG_LO": {
      "id": "KEYD_RNG_LO",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "Key Range D Low",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "KEYD_RNG_HI": {
      "id": "KEYD_RNG_HI",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "Key Range D High",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "BND_RNG_DW": {
      "id": "BND_RNG_DW",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "Bender Range Down",
      "dataRange": [
        0,
        48
      ],
      "initValue": 2
    },
    "BND_RNG_UP": {
      "id": "BND_RNG_UP",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "Bender Range Up",
      "dataRange": [
        0,
        12
      ],
      "initValue": 2
    },
    "AFT_BEND": {
      "id": "AFT_BEND",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "After Touch Bend Sens",
      "dataRange": [
        0,
        26
      ],
      "initValue": 16,
      "values": {
        "0": "-36",
        "1": "-24",
        "2": "-12",
        "3": "-11",
        "4": "-10",
        "5": "-9",
        "6": "-8",
        "7": "-7",
        "8": "-6",
        "9": "-5",
        "10": "-4",
        "11": "-3",
        "12": "-2",
        "13": "-1",
        "14": "0",
        "15": "+1",
        "16": "+2",
        "17": "+3",
        "18": "+4",
        "19": "+5",
        "20": "+6",
        "21": "+7",
        "22": "+8",
        "23": "+9",
        "24": "+10",
        "25": "+11",
        "26": "+12"
      }
    },
    "SOLO_SW": {
      "id": "SOLO_SW",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "Solo Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "LEGATO_SW": {
      "id": "LEGATO_SW",
      "byteOffset": 13,
      "byteLength": 1,
      "description": "Solo Legato Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PORT_SW": {
      "id": "PORT_SW",
      "byteOffset": 14,
      "byteLength": 1,
      "description": "Portamento Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PORT_MODE": {
      "id": "PORT_MODE",
      "byteOffset": 15,
      "byteLength": 1,
      "description": "Portamento Mode",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "NORMAL",
        "1": "LEGATO"
      }
    },
    "PORT_TIME": {
      "id": "PORT_TIME",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "Portamento Time",
      "dataRange": [
        0,
        100
      ],
      "initValue": 10
    },
    "EQ_MID_Q": {
      "id": "EQ_MID_Q",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "EQ Mid Q",
      "dataRange": [
        5,
        160
      ],
      "initValue": 10,
      "displayMeasurement": "EQQ",
      "displayRange": [
        0.5,
        16
      ]
    },
    "EQ_LO_F": {
      "id": "EQ_LO_F",
      "byteOffset": 18,
      "byteLength": 2,
      "description": "EQ Low Frequency",
      "dataRange": [
        20,
        16000
      ],
      "initValue": 200
    },
    "EQ_MID_F": {
      "id": "EQ_MID_F",
      "byteOffset": 20,
      "byteLength": 2,
      "description": "EQ Mid Frequency",
      "dataRange": [
        20,
        16000
      ],
      "initValue": 1000
    },
    "EQ_HI_F": {
      "id": "EQ_HI_F",
      "byteOffset": 22,
      "byteLength": 2,
      "description": "EQ High Frequency",
      "dataRange": [
        20,
        16000
      ],
      "initValue": 2000
    },
    "EQ_LO_G": {
      "id": "EQ_LO_G",
      "byteOffset": 24,
      "byteLength": 2,
      "description": "EQ Low Gain",
      "dataRange": [
        -240,
        240
      ],
      "initValue": 0,
      "displayMeasurement": "EQGAIN",
      "displayRange": [
        -24,
        24
      ]
    },
    "EQ_MID_G": {
      "id": "EQ_MID_G",
      "byteOffset": 26,
      "byteLength": 2,
      "description": "EQ Mid Gain",
      "dataRange": [
        -240,
        240
      ],
      "initValue": 0,
      "displayMeasurement": "EQGAIN",
      "displayRange": [
        -24,
        24
      ]
    },
    "EQ_HI_G": {
      "id": "EQ_HI_G",
      "byteOffset": 28,
      "byteLength": 2,
      "description": "EQ High Gain",
      "dataRange": [
        -240,
        240
      ],
      "initValue": 0,
      "displayMeasurement": "EQGAIN",
      "displayRange": [
        -24,
        24
      ]
    },
    "EQ_SW": {
      "id": "EQ_SW",
      "byteOffset": 30,
      "byteLength": 1,
      "description": "EQ Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "UNISON": {
      "id": "UNISON",
      "byteOffset": 31,
      "byteLength": 1,
      "description": "Unison Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 32,
      "byteLength": 12,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MDLJD800FxB"] = {
  "name": "MDLJD800FxB",
  "description": "JD-800 Model Group B Effect",
  "byteLength": 32,
  "parameters": {
    "SEQUENCE": {
      "id": "SEQUENCE",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Sequence",
      "dataRange": [
        0,
        5
      ],
      "initValue": 0,
      "values": {
        "0": "CHO-DLY-REV",
        "1": "CHO-REV-DLY",
        "2": "DLY-CHO-REV",
        "3": "DLY-REV-CHO",
        "4": "REV-CHO-DLY",
        "5": "REV-DLY-CHO"
      }
    },
    "DLY_SW": {
      "id": "DLY_SW",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "DL Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "DLY_C_SYNC": {
      "id": "DLY_C_SYNC",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "Delay Center (sync sw)",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "DLY_C_TIME": {
      "id": "DLY_C_TIME",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "Delay Center (time)",
      "dataRange": [
        0,
        125
      ],
      "initValue": 125,
      "displayMeasurement": "msec",
      "values": {
        "0": "0.1",
        "1": "0.2",
        "2": "0.3",
        "3": "0.4",
        "4": "0.5",
        "5": "0.6",
        "6": "0.7",
        "7": "0.8",
        "8": "0.9",
        "9": "1.0",
        "10": "1.1",
        "11": "1.2",
        "12": "1.3",
        "13": "1.4",
        "14": "1.5",
        "15": "1.6",
        "16": "1.7",
        "17": "1.8",
        "18": "1.9",
        "19": "2.0",
        "20": "2.1",
        "21": "2.2",
        "22": "2.3",
        "23": "2.4",
        "24": "2.5",
        "25": "2.6",
        "26": "2.7",
        "27": "2.8",
        "28": "2.9",
        "29": "3.0",
        "30": "3.1",
        "31": "3.2",
        "32": "3.3",
        "33": "3.4",
        "34": "3.5",
        "35": "3.6",
        "36": "3.7",
        "37": "3.8",
        "38": "3.9",
        "39": "4.0",
        "40": "4.1",
        "41": "4.2",
        "42": "4.3",
        "43": "4.4",
        "44": "4.5",
        "45": "4.6",
        "46": "4.7",
        "47": "4.8",
        "48": "4.9",
        "49": "5.0",
        "50": "5.5",
        "51": "6.0",
        "52": "6.5",
        "53": "7.0",
        "54": "7.5",
        "55": "8.0",
        "56": "8.5",
        "57": "9.0",
        "58": "9.5",
        "59": "10.0",
        "60": "11.0",
        "61": "12.0",
        "62": "13.0",
        "63": "14.0",
        "64": "15.0",
        "65": "16.0",
        "66": "17.0",
        "67": "18.0",
        "68": "19.0",
        "69": "20.0",
        "70": "21.0",
        "71": "22.0",
        "72": "23.0",
        "73": "24.0",
        "74": "25.0",
        "75": "26.0",
        "76": "27.0",
        "77": "28.0",
        "78": "29.0",
        "79": "30.0",
        "80": "31.0",
        "81": "32.0",
        "82": "33.0",
        "83": "34.0",
        "84": "35.0",
        "85": "36.0",
        "86": "37.0",
        "87": "38.0",
        "88": "39.0",
        "89": "40.0",
        "90": "50.0",
        "91": "60.0",
        "92": "70.0",
        "93": "80.0",
        "94": "90.0",
        "95": "100.0",
        "96": "110.0",
        "97": "120.0",
        "98": "130.0",
        "99": "140.0",
        "100": "150.0",
        "101": "160.0",
        "102": "170.0",
        "103": "180.0",
        "104": "190.0",
        "105": "200.0",
        "106": "220.0",
        "107": "240.0",
        "108": "260.0",
        "109": "280.0",
        "110": "300.0",
        "111": "320.0",
        "112": "340.0",
        "113": "360.0",
        "114": "380.0",
        "115": "400.0",
        "116": "420.0",
        "117": "440.0",
        "118": "460.0",
        "119": "480.0",
        "120": "500.0",
        "121": "520.0",
        "122": "540.0",
        "123": "560.0",
        "124": "580.0",
        "125": "600.0"
      }
    },
    "DLY_C_NOTE": {
      "id": "DLY_C_NOTE",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "Delay Center (note)",
      "dataRange": [
        0,
        21
      ],
      "initValue": 15,
      "values": {
        "0": "MUSICAL-NOTES"
      }
    },
    "DLY_L_SYNC": {
      "id": "DLY_L_SYNC",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "Delay Left (sync sw)",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "DLY_L_TIME": {
      "id": "DLY_L_TIME",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "Delay Left (time)",
      "dataRange": [
        0,
        125
      ],
      "initValue": 105,
      "displayMeasurement": "msec",
      "values": {
        "0": "0.1",
        "1": "0.2",
        "2": "0.3",
        "3": "0.4",
        "4": "0.5",
        "5": "0.6",
        "6": "0.7",
        "7": "0.8",
        "8": "0.9",
        "9": "1.0",
        "10": "1.1",
        "11": "1.2",
        "12": "1.3",
        "13": "1.4",
        "14": "1.5",
        "15": "1.6",
        "16": "1.7",
        "17": "1.8",
        "18": "1.9",
        "19": "2.0",
        "20": "2.1",
        "21": "2.2",
        "22": "2.3",
        "23": "2.4",
        "24": "2.5",
        "25": "2.6",
        "26": "2.7",
        "27": "2.8",
        "28": "2.9",
        "29": "3.0",
        "30": "3.1",
        "31": "3.2",
        "32": "3.3",
        "33": "3.4",
        "34": "3.5",
        "35": "3.6",
        "36": "3.7",
        "37": "3.8",
        "38": "3.9",
        "39": "4.0",
        "40": "4.1",
        "41": "4.2",
        "42": "4.3",
        "43": "4.4",
        "44": "4.5",
        "45": "4.6",
        "46": "4.7",
        "47": "4.8",
        "48": "4.9",
        "49": "5.0",
        "50": "5.5",
        "51": "6.0",
        "52": "6.5",
        "53": "7.0",
        "54": "7.5",
        "55": "8.0",
        "56": "8.5",
        "57": "9.0",
        "58": "9.5",
        "59": "10.0",
        "60": "11.0",
        "61": "12.0",
        "62": "13.0",
        "63": "14.0",
        "64": "15.0",
        "65": "16.0",
        "66": "17.0",
        "67": "18.0",
        "68": "19.0",
        "69": "20.0",
        "70": "21.0",
        "71": "22.0",
        "72": "23.0",
        "73": "24.0",
        "74": "25.0",
        "75": "26.0",
        "76": "27.0",
        "77": "28.0",
        "78": "29.0",
        "79": "30.0",
        "80": "31.0",
        "81": "32.0",
        "82": "33.0",
        "83": "34.0",
        "84": "35.0",
        "85": "36.0",
        "86": "37.0",
        "87": "38.0",
        "88": "39.0",
        "89": "40.0",
        "90": "50.0",
        "91": "60.0",
        "92": "70.0",
        "93": "80.0",
        "94": "90.0",
        "95": "100.0",
        "96": "110.0",
        "97": "120.0",
        "98": "130.0",
        "99": "140.0",
        "100": "150.0",
        "101": "160.0",
        "102": "170.0",
        "103": "180.0",
        "104": "190.0",
        "105": "200.0",
        "106": "220.0",
        "107": "240.0",
        "108": "260.0",
        "109": "280.0",
        "110": "300.0",
        "111": "320.0",
        "112": "340.0",
        "113": "360.0",
        "114": "380.0",
        "115": "400.0",
        "116": "420.0",
        "117": "440.0",
        "118": "460.0",
        "119": "480.0",
        "120": "500.0",
        "121": "520.0",
        "122": "540.0",
        "123": "560.0",
        "124": "580.0",
        "125": "600.0"
      }
    },
    "DLY_L_NOTE": {
      "id": "DLY_L_NOTE",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "Delay Left (note)",
      "dataRange": [
        0,
        21
      ],
      "initValue": 10,
      "values": {
        "0": "MUSICAL-NOTES"
      }
    },
    "DLY_R_SYNC": {
      "id": "DLY_R_SYNC",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "Delay Right (sync sw)",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "DLY_R_TIME": {
      "id": "DLY_R_TIME",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "Delay Right (time)",
      "dataRange": [
        0,
        125
      ],
      "initValue": 115,
      "displayMeasurement": "msec",
      "values": {
        "0": "0.1",
        "1": "0.2",
        "2": "0.3",
        "3": "0.4",
        "4": "0.5",
        "5": "0.6",
        "6": "0.7",
        "7": "0.8",
        "8": "0.9",
        "9": "1.0",
        "10": "1.1",
        "11": "1.2",
        "12": "1.3",
        "13": "1.4",
        "14": "1.5",
        "15": "1.6",
        "16": "1.7",
        "17": "1.8",
        "18": "1.9",
        "19": "2.0",
        "20": "2.1",
        "21": "2.2",
        "22": "2.3",
        "23": "2.4",
        "24": "2.5",
        "25": "2.6",
        "26": "2.7",
        "27": "2.8",
        "28": "2.9",
        "29": "3.0",
        "30": "3.1",
        "31": "3.2",
        "32": "3.3",
        "33": "3.4",
        "34": "3.5",
        "35": "3.6",
        "36": "3.7",
        "37": "3.8",
        "38": "3.9",
        "39": "4.0",
        "40": "4.1",
        "41": "4.2",
        "42": "4.3",
        "43": "4.4",
        "44": "4.5",
        "45": "4.6",
        "46": "4.7",
        "47": "4.8",
        "48": "4.9",
        "49": "5.0",
        "50": "5.5",
        "51": "6.0",
        "52": "6.5",
        "53": "7.0",
        "54": "7.5",
        "55": "8.0",
        "56": "8.5",
        "57": "9.0",
        "58": "9.5",
        "59": "10.0",
        "60": "11.0",
        "61": "12.0",
        "62": "13.0",
        "63": "14.0",
        "64": "15.0",
        "65": "16.0",
        "66": "17.0",
        "67": "18.0",
        "68": "19.0",
        "69": "20.0",
        "70": "21.0",
        "71": "22.0",
        "72": "23.0",
        "73": "24.0",
        "74": "25.0",
        "75": "26.0",
        "76": "27.0",
        "77": "28.0",
        "78": "29.0",
        "79": "30.0",
        "80": "31.0",
        "81": "32.0",
        "82": "33.0",
        "83": "34.0",
        "84": "35.0",
        "85": "36.0",
        "86": "37.0",
        "87": "38.0",
        "88": "39.0",
        "89": "40.0",
        "90": "50.0",
        "91": "60.0",
        "92": "70.0",
        "93": "80.0",
        "94": "90.0",
        "95": "100.0",
        "96": "110.0",
        "97": "120.0",
        "98": "130.0",
        "99": "140.0",
        "100": "150.0",
        "101": "160.0",
        "102": "170.0",
        "103": "180.0",
        "104": "190.0",
        "105": "200.0",
        "106": "220.0",
        "107": "240.0",
        "108": "260.0",
        "109": "280.0",
        "110": "300.0",
        "111": "320.0",
        "112": "340.0",
        "113": "360.0",
        "114": "380.0",
        "115": "400.0",
        "116": "420.0",
        "117": "440.0",
        "118": "460.0",
        "119": "480.0",
        "120": "500.0",
        "121": "520.0",
        "122": "540.0",
        "123": "560.0",
        "124": "580.0",
        "125": "600.0"
      }
    },
    "DLY_R_NOTE": {
      "id": "DLY_R_NOTE",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "Delay Right (note)",
      "dataRange": [
        0,
        21
      ],
      "initValue": 13,
      "values": {
        "0": "MUSICAL-NOTES"
      }
    },
    "DLY_C_LEV": {
      "id": "DLY_C_LEV",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "Center Level",
      "dataRange": [
        0,
        100
      ],
      "initValue": 100
    },
    "DLY_L_LEV": {
      "id": "DLY_L_LEV",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "Left Level",
      "dataRange": [
        0,
        100
      ],
      "initValue": 100
    },
    "DLY_R_LEV": {
      "id": "DLY_R_LEV",
      "byteOffset": 13,
      "byteLength": 1,
      "description": "Right Level",
      "dataRange": [
        0,
        100
      ],
      "initValue": 100
    },
    "DLY_FB": {
      "id": "DLY_FB",
      "byteOffset": 14,
      "byteLength": 1,
      "description": "Delay Feedback",
      "dataRange": [
        0,
        98
      ],
      "initValue": 59,
      "displayMeasurement": "%",
      "displayRange": [
        -98,
        98
      ]
    },
    "CHO_SW": {
      "id": "CHO_SW",
      "byteOffset": 15,
      "byteLength": 1,
      "description": "Chorus Sw",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "CHO_RATE": {
      "id": "CHO_RATE",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "Chorus Rate",
      "dataRange": [
        0,
        99
      ],
      "initValue": 5,
      "displayMeasurement": "Hz",
      "displayRange": [
        0.1,
        10
      ]
    },
    "CHO_DEPTH": {
      "id": "CHO_DEPTH",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "Chorus Depth",
      "dataRange": [
        0,
        100
      ],
      "initValue": 20
    },
    "CHO_DLY": {
      "id": "CHO_DLY",
      "byteOffset": 18,
      "byteLength": 1,
      "description": "Chorus Delay",
      "dataRange": [
        0,
        99
      ],
      "initValue": 19,
      "displayMeasurement": "msec",
      "values": {
        "0": "0.1",
        "1": "0.2",
        "2": "0.3",
        "3": "0.4",
        "4": "0.5",
        "5": "0.6",
        "6": "0.7",
        "7": "0.8",
        "8": "0.9",
        "9": "1.0",
        "10": "1.1",
        "11": "1.2",
        "12": "1.3",
        "13": "1.4",
        "14": "1.5",
        "15": "1.6",
        "16": "1.7",
        "17": "1.8",
        "18": "1.9",
        "19": "2.0",
        "20": "2.1",
        "21": "2.2",
        "22": "2.3",
        "23": "2.4",
        "24": "2.5",
        "25": "2.6",
        "26": "2.7",
        "27": "2.8",
        "28": "2.9",
        "29": "3.0",
        "30": "3.1",
        "31": "3.2",
        "32": "3.3",
        "33": "3.4",
        "34": "3.5",
        "35": "3.6",
        "36": "3.7",
        "37": "3.8",
        "38": "3.9",
        "39": "4.0",
        "40": "4.1",
        "41": "4.2",
        "42": "4.3",
        "43": "4.4",
        "44": "4.5",
        "45": "4.6",
        "46": "4.7",
        "47": "4.8",
        "48": "4.9",
        "49": "5.0",
        "50": "5.5",
        "51": "6.0",
        "52": "6.5",
        "53": "7.0",
        "54": "7.5",
        "55": "8.0",
        "56": "8.5",
        "57": "9.0",
        "58": "9.5",
        "59": "10.0",
        "60": "11.0",
        "61": "12.0",
        "62": "13.0",
        "63": "14.0",
        "64": "15.0",
        "65": "16.0",
        "66": "17.0",
        "67": "18.0",
        "68": "19.0",
        "69": "20.0",
        "70": "21.0",
        "71": "22.0",
        "72": "23.0",
        "73": "24.0",
        "74": "25.0",
        "75": "26.0",
        "76": "27.0",
        "77": "28.0",
        "78": "29.0",
        "79": "30.0",
        "80": "31.0",
        "81": "32.0",
        "82": "33.0",
        "83": "34.0",
        "84": "35.0",
        "85": "36.0",
        "86": "37.0",
        "87": "38.0",
        "88": "39.0",
        "89": "40.0",
        "90": "41.0",
        "91": "42.0",
        "92": "43.0",
        "93": "44.0",
        "94": "45.0",
        "95": "46.0",
        "96": "47.0",
        "97": "48.0",
        "98": "49.0",
        "99": "50.0"
      }
    },
    "CHO_FB": {
      "id": "CHO_FB",
      "byteOffset": 19,
      "byteLength": 1,
      "description": "Chorus Feedback",
      "dataRange": [
        0,
        98
      ],
      "initValue": 49,
      "displayMeasurement": "%",
      "displayRange": [
        -98,
        98
      ]
    },
    "CHO_LEV": {
      "id": "CHO_LEV",
      "byteOffset": 20,
      "byteLength": 1,
      "description": "Chorus Level",
      "dataRange": [
        0,
        100
      ],
      "initValue": 100
    },
    "REV_SW": {
      "id": "REV_SW",
      "byteOffset": 21,
      "byteLength": 1,
      "description": "Reverb Sw",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "REV_TYPE": {
      "id": "REV_TYPE",
      "byteOffset": 22,
      "byteLength": 1,
      "description": "Reverb Type",
      "dataRange": [
        0,
        9
      ],
      "initValue": 5,
      "values": {
        "0": "ROOM1",
        "1": "ROOM2",
        "2": "HALL1",
        "3": "HALL2",
        "4": "HALL3",
        "5": "HALL4",
        "6": "GATE",
        "7": "REVERSE",
        "8": "FLYING1",
        "9": "FLYING2"
      }
    },
    "REV_DLY": {
      "id": "REV_DLY",
      "byteOffset": 23,
      "byteLength": 1,
      "description": "Reverb Pre Delay",
      "dataRange": [
        0,
        120
      ],
      "initValue": 20,
      "displayMeasurement": "msec"
    },
    "REV_ER_LEV": {
      "id": "REV_ER_LEV",
      "byteOffset": 24,
      "byteLength": 1,
      "description": "Reverb ER Lev",
      "dataRange": [
        0,
        100
      ],
      "initValue": 100
    },
    "REV_HF_DAMP": {
      "id": "REV_HF_DAMP",
      "byteOffset": 25,
      "byteLength": 1,
      "description": "Reverb HF Damp",
      "dataRange": [
        0,
        16
      ],
      "initValue": 16,
      "values": {
        "0": "500Hz",
        "1": "630Hz",
        "2": "800Hz",
        "3": "1kHz",
        "4": "1.25kHz",
        "5": "1.6kHz",
        "6": "2kHz",
        "7": "2.5kHz",
        "8": "3.15kHz",
        "9": "4kHz",
        "10": "5kHz",
        "11": "6.3kHz",
        "12": "8kHz",
        "13": "10kHz",
        "14": "12.5kHz",
        "15": "16kHz",
        "16": "BYPASS"
      }
    },
    "REV_TIME": {
      "id": "REV_TIME",
      "byteOffset": 26,
      "byteLength": 1,
      "description": "Reverb Time",
      "dataRange": [
        0,
        99
      ],
      "initValue": 19,
      "displayMeasurement": "sec",
      "values": {
        "0": "0.1",
        "1": "0.2",
        "2": "0.3",
        "3": "0.4",
        "4": "0.5",
        "5": "0.6",
        "6": "0.7",
        "7": "0.8",
        "8": "0.9",
        "9": "1.0",
        "10": "1.1",
        "11": "1.2",
        "12": "1.3",
        "13": "1.4",
        "14": "1.5",
        "15": "1.6",
        "16": "1.7",
        "17": "1.8",
        "18": "1.9",
        "19": "2.0",
        "20": "2.1",
        "21": "2.2",
        "22": "2.3",
        "23": "2.4",
        "24": "2.5",
        "25": "2.6",
        "26": "2.7",
        "27": "2.8",
        "28": "2.9",
        "29": "3.0",
        "30": "3.1",
        "31": "3.2",
        "32": "3.3",
        "33": "3.4",
        "34": "3.5",
        "35": "3.6",
        "36": "3.7",
        "37": "3.8",
        "38": "3.9",
        "39": "4.0",
        "40": "4.1",
        "41": "4.2",
        "42": "4.3",
        "43": "4.4",
        "44": "4.5",
        "45": "4.6",
        "46": "4.7",
        "47": "4.8",
        "48": "4.9",
        "49": "5.0",
        "50": "5.1",
        "51": "5.2",
        "52": "5.3",
        "53": "5.4",
        "54": "5.5",
        "55": "5.6",
        "56": "5.7",
        "57": "5.8",
        "58": "5.9",
        "59": "6.0",
        "60": "6.1",
        "61": "6.2",
        "62": "6.3",
        "63": "6.4",
        "64": "6.5",
        "65": "6.6",
        "66": "6.7",
        "67": "6.8",
        "68": "6.9",
        "69": "7.0",
        "70": "7.1",
        "71": "7.2",
        "72": "7.3",
        "73": "7.4",
        "74": "7.5",
        "75": "7.6",
        "76": "7.7",
        "77": "7.8",
        "78": "7.9",
        "79": "8.0",
        "80": "8.5",
        "81": "9.0",
        "82": "9.5",
        "83": "10.0",
        "84": "10.5",
        "85": "11.0",
        "86": "11.5",
        "87": "12.0",
        "88": "12.5",
        "89": "13.0",
        "90": "13.5",
        "91": "14.0",
        "92": "14.5",
        "93": "15.0",
        "94": "15.5",
        "95": "16.0",
        "96": "17.0",
        "97": "18.0",
        "98": "19.0",
        "99": "20.0"
      }
    },
    "REV_LEV": {
      "id": "REV_LEV",
      "byteOffset": 27,
      "byteLength": 1,
      "description": "Reverb Level",
      "dataRange": [
        0,
        100
      ],
      "initValue": 100
    },
    "BAL": {
      "id": "BAL",
      "byteOffset": 28,
      "byteLength": 1,
      "description": "Balance",
      "dataRange": [
        0,
        100
      ],
      "initValue": 50,
      "values": {
        "0": "D100:0W - D0:100W"
      }
    },
    "LEVEL": {
      "id": "LEVEL",
      "byteOffset": 29,
      "byteLength": 1,
      "description": "Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 30,
      "byteLength": 2,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MDLJD800PTL"] = {
  "name": "MDLJD800PTL",
  "description": "JD-800 Model Partial",
  "byteLength": 80,
  "parameters": {
    "PTL_SW": {
      "id": "PTL_SW",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Layer Partial Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "ACT_SW": {
      "id": "ACT_SW",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "Active Partial Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "VELO_CRV": {
      "id": "VELO_CRV",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "Velocity Curve",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "displayRange": [
        1,
        4
      ]
    },
    "HOLD_CTRL": {
      "id": "HOLD_CTRL",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "Hold Control Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "LFO1_WAV": {
      "id": "LFO1_WAV",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "LFO1:Waveform",
      "dataRange": [
        0,
        4
      ],
      "initValue": 0,
      "values": {
        "0": "TRI",
        "1": "SAW",
        "2": "SQU",
        "3": "S&H",
        "4": "RND"
      }
    },
    "LFO1_SYNC": {
      "id": "LFO1_SYNC",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "LFO1:Rate sync",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "LFO1_RATE": {
      "id": "LFO1_RATE",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "LFO1:Rate",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "LFO1_NOTE": {
      "id": "LFO1_NOTE",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "LFO1:Rate nt",
      "dataRange": [
        0,
        22
      ],
      "initValue": 12,
      "values": {
        "0": "1/64T",
        "1": "1/64",
        "2": "1/32T",
        "3": "1/32",
        "4": "1/16T",
        "5": "1/32.",
        "6": "1/16",
        "7": "1/8T",
        "8": "1/16.",
        "9": "1/8",
        "10": "1/4T",
        "11": "1/8.",
        "12": "1/4",
        "13": "1/2T",
        "14": "1/4.",
        "15": "1/2",
        "16": "1T",
        "17": "1/2.",
        "18": "1",
        "19": "2T",
        "20": "1.",
        "21": "2",
        "22": "4"
      }
    },
    "LFO1_DLY": {
      "id": "LFO1_DLY",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "LFO1:Delay time",
      "dataRange": [
        0,
        101
      ],
      "initValue": 0
    },
    "LFO1_FADE": {
      "id": "LFO1_FADE",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "LFO1:Fade time",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "LFO1_OFST": {
      "id": "LFO1_OFST",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "LFO1:Offset",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "-",
        "1": "0",
        "2": "+"
      }
    },
    "LFO1_KEY": {
      "id": "LFO1_KEY",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "LFO1:Key trig",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "LFO2_WAV": {
      "id": "LFO2_WAV",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "LFO2:Waveform",
      "dataRange": [
        0,
        4
      ],
      "initValue": 0,
      "values": {
        "0": "TRI",
        "1": "SAW",
        "2": "SQU",
        "3": "S&H",
        "4": "RND"
      }
    },
    "LFO2_SYNC": {
      "id": "LFO2_SYNC",
      "byteOffset": 13,
      "byteLength": 1,
      "description": "LFO2:Rate Sync",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "LFO2_RATE": {
      "id": "LFO2_RATE",
      "byteOffset": 14,
      "byteLength": 1,
      "description": "LFO2:Rate",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "LFO2_NOTE": {
      "id": "LFO2_NOTE",
      "byteOffset": 15,
      "byteLength": 1,
      "description": "LFO2:Rate nt",
      "dataRange": [
        0,
        22
      ],
      "initValue": 12,
      "values": {
        "0": "1/64T",
        "1": "1/64",
        "2": "1/32T",
        "3": "1/32",
        "4": "1/16T",
        "5": "1/32.",
        "6": "1/16",
        "7": "1/8T",
        "8": "1/16.",
        "9": "1/8",
        "10": "1/4T",
        "11": "1/8.",
        "12": "1/4",
        "13": "1/2T",
        "14": "1/4.",
        "15": "1/2",
        "16": "1T",
        "17": "1/2.",
        "18": "1",
        "19": "2T",
        "20": "1.",
        "21": "2",
        "22": "4"
      }
    },
    "LFO2_DLY": {
      "id": "LFO2_DLY",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "LFO2:Delay Time",
      "dataRange": [
        0,
        101
      ],
      "initValue": 0
    },
    "LFO2_FADE": {
      "id": "LFO2_FADE",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "LFO2:Fade time",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "LFO2_OFST": {
      "id": "LFO2_OFST",
      "byteOffset": 18,
      "byteLength": 1,
      "description": "LFO2:Offset",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "-",
        "1": "0",
        "2": "+"
      }
    },
    "LFO2_KEY": {
      "id": "LFO2_KEY",
      "byteOffset": 19,
      "byteLength": 1,
      "description": "LFO2:Key trig",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "WAV_NUM": {
      "id": "WAV_NUM",
      "byteOffset": 20,
      "byteLength": 2,
      "description": "WG:Waveform",
      "dataRange": [
        0,
        16383
      ],
      "initValue": 0
    },
    "WAV_SRC": {
      "id": "WAV_SRC",
      "byteOffset": 22,
      "byteLength": 1,
      "description": "WG:Wave source",
      "dataRange": [
        0,
        49
      ],
      "initValue": 0
    },
    "WAV_GAIN": {
      "id": "WAV_GAIN",
      "byteOffset": 23,
      "byteLength": 1,
      "description": "WG:Wave gain",
      "dataRange": [
        0,
        5
      ],
      "initValue": 3,
      "displayMeasurement": "dB",
      "values": {
        "0": "-18",
        "1": "-12",
        "2": "-6",
        "3": "0",
        "4": "+6",
        "5": "+12"
      }
    },
    "PIT_COARSE": {
      "id": "PIT_COARSE",
      "byteOffset": 24,
      "byteLength": 1,
      "description": "WG:Pitch coarse",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0
    },
    "PIT_FINE": {
      "id": "PIT_FINE",
      "byteOffset": 25,
      "byteLength": 1,
      "description": "WG:Pitch fine",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "PIT_RND": {
      "id": "PIT_RND",
      "byteOffset": 26,
      "byteLength": 1,
      "description": "WG:Pitch random",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "PIT_KF": {
      "id": "PIT_KF",
      "byteOffset": 27,
      "byteLength": 1,
      "description": "WG:Pitch KF",
      "dataRange": [
        0,
        16
      ],
      "initValue": 5,
      "displayMeasurement": "%",
      "values": {
        "0": "-100",
        "1": "-50",
        "2": "-20",
        "3": "-10",
        "4": "-5",
        "5": "0",
        "6": "+5",
        "7": "+10",
        "8": "+20",
        "9": "+50",
        "10": "+98",
        "11": "+99",
        "12": "+100",
        "13": "+101",
        "14": "+102",
        "15": "+150",
        "16": "+200"
      }
    },
    "BENDER_SW": {
      "id": "BENDER_SW",
      "byteOffset": 28,
      "byteLength": 1,
      "description": "WG:Bender Sw",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "AFT_BEND_SW": {
      "id": "AFT_BEND_SW",
      "byteOffset": 29,
      "byteLength": 1,
      "description": "WG:Atch bend sw",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "LFO1_DEP": {
      "id": "LFO1_DEP",
      "byteOffset": 30,
      "byteLength": 1,
      "description": "WG:LFO1 depth",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "LFO2_DEP": {
      "id": "LFO2_DEP",
      "byteOffset": 31,
      "byteLength": 1,
      "description": "WG:LFO2 depth",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "LEVER_SENS": {
      "id": "LEVER_SENS",
      "byteOffset": 32,
      "byteLength": 1,
      "description": "WG:Lever sens",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "AFT_SENS": {
      "id": "AFT_SENS",
      "byteOffset": 33,
      "byteLength": 1,
      "description": "WG:Atch msens",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "PENV_VSENS": {
      "id": "PENV_VSENS",
      "byteOffset": 34,
      "byteLength": 1,
      "description": "Pitch Env Velocity Sens",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "PENV_T_VS": {
      "id": "PENV_T_VS",
      "byteOffset": 35,
      "byteLength": 1,
      "description": "Pitch Env Time Velocity Sens",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "PENV_T_KF": {
      "id": "PENV_T_KF",
      "byteOffset": 36,
      "byteLength": 1,
      "description": "Pitch Env Time Keyfollow",
      "dataRange": [
        -10,
        10
      ],
      "initValue": 0
    },
    "PENV_L0": {
      "id": "PENV_L0",
      "byteOffset": 37,
      "byteLength": 1,
      "description": "Pitch Env L0",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "PENV_L1": {
      "id": "PENV_L1",
      "byteOffset": 38,
      "byteLength": 1,
      "description": "Pitch Env L1",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "PENV_L2": {
      "id": "PENV_L2",
      "byteOffset": 39,
      "byteLength": 1,
      "description": "Pitch Env L2",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "PENV_T1": {
      "id": "PENV_T1",
      "byteOffset": 40,
      "byteLength": 1,
      "description": "Pitch Env T1",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "PENV_T2": {
      "id": "PENV_T2",
      "byteOffset": 41,
      "byteLength": 1,
      "description": "Pitch Env T2",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "PENV_T3": {
      "id": "PENV_T3",
      "byteOffset": 42,
      "byteLength": 1,
      "description": "Pitch Env T3",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "TVF_FLT": {
      "id": "TVF_FLT",
      "byteOffset": 43,
      "byteLength": 1,
      "description": "TVF:Filter mode",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "LPF",
        "1": "BPF",
        "2": "HPF"
      }
    },
    "TVF_CUTOFF": {
      "id": "TVF_CUTOFF",
      "byteOffset": 44,
      "byteLength": 1,
      "description": "TVF:Cutoff freq",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "TVF_RESO": {
      "id": "TVF_RESO",
      "byteOffset": 45,
      "byteLength": 1,
      "description": "TVF:Resonance",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "TVF_KF": {
      "id": "TVF_KF",
      "byteOffset": 46,
      "byteLength": 1,
      "description": "TVF:Cutoff KF",
      "dataRange": [
        0,
        40
      ],
      "initValue": 0,
      "displayMeasurement": "%",
      "values": {
        "0": "-100 ",
        "1": "-90 ",
        "2": "-80 ",
        "3": "-70 ",
        "4": "-60 ",
        "5": "-50 ",
        "6": "-40 ",
        "7": "-30 ",
        "8": "-20 ",
        "9": "-10 ",
        "10": "0 ",
        "11": "+5 ",
        "12": "+10 ",
        "13": "+15 ",
        "14": "+20 ",
        "15": "+25 ",
        "16": "+30 ",
        "17": "+35 ",
        "18": "+40 ",
        "19": "+45 ",
        "20": "+50 ",
        "21": "+55 ",
        "22": "+60 ",
        "23": "+65 ",
        "24": "+70 ",
        "25": "+75 ",
        "26": "+80 ",
        "27": "+85 ",
        "28": "+90 ",
        "29": "+95 ",
        "30": "+100 ",
        "31": "+105 ",
        "32": "+110 ",
        "33": "+115 ",
        "34": "+120 ",
        "35": "+125 ",
        "36": "+130 ",
        "37": "+135 ",
        "38": "+140 ",
        "39": "+145 ",
        "40": "+150"
      }
    },
    "TVF_AFT": {
      "id": "TVF_AFT",
      "byteOffset": 47,
      "byteLength": 1,
      "description": "TVF:Atch sens",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "TVF_LFO": {
      "id": "TVF_LFO",
      "byteOffset": 48,
      "byteLength": 1,
      "description": "TVF:LFO select",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "LFO1 ",
        "1": "LFO2"
      }
    },
    "TVF_LFO_DEP": {
      "id": "TVF_LFO_DEP",
      "byteOffset": 49,
      "byteLength": 1,
      "description": "TVF:LFO depth",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "TVF_ENV_DEP": {
      "id": "TVF_ENV_DEP",
      "byteOffset": 50,
      "byteLength": 1,
      "description": "TVF:ENV depth",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "FENV_VSENS": {
      "id": "FENV_VSENS",
      "byteOffset": 51,
      "byteLength": 1,
      "description": "F-ENV:Velo sens",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "FENV_T_VS": {
      "id": "FENV_T_VS",
      "byteOffset": 52,
      "byteLength": 1,
      "description": "F-ENV:T vsens",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "FENV_T_KF": {
      "id": "FENV_T_KF",
      "byteOffset": 53,
      "byteLength": 1,
      "description": "F-ENV:Time KF",
      "dataRange": [
        -10,
        10
      ],
      "initValue": 0
    },
    "FENV_L1": {
      "id": "FENV_L1",
      "byteOffset": 54,
      "byteLength": 1,
      "description": "F-ENV:Level 1",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "FENV_L2": {
      "id": "FENV_L2",
      "byteOffset": 55,
      "byteLength": 1,
      "description": "F-ENV:Level 2",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "FENV_SUS": {
      "id": "FENV_SUS",
      "byteOffset": 56,
      "byteLength": 1,
      "description": "F-ENV:Sus Level",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "FENV_L4": {
      "id": "FENV_L4",
      "byteOffset": 57,
      "byteLength": 1,
      "description": "F-ENV:Level 4",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "FENV_T1": {
      "id": "FENV_T1",
      "byteOffset": 58,
      "byteLength": 1,
      "description": "F-ENV:Time 1",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "FENV_T2": {
      "id": "FENV_T2",
      "byteOffset": 59,
      "byteLength": 1,
      "description": "F-ENV:Time 2",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "FENV_T3": {
      "id": "FENV_T3",
      "byteOffset": 60,
      "byteLength": 1,
      "description": "F-ENV:Time 3",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "FENV_T4": {
      "id": "FENV_T4",
      "byteOffset": 61,
      "byteLength": 1,
      "description": "F-ENV:Time 4",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "TVA_BS_DIR": {
      "id": "TVA_BS_DIR",
      "byteOffset": 62,
      "byteLength": 1,
      "description": "TVA Bias Direction",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "UP ",
        "1": "LOW",
        "2": "U&L"
      }
    },
    "TVA_BS_KEY": {
      "id": "TVA_BS_KEY",
      "byteOffset": 63,
      "byteLength": 1,
      "description": "TVA Bias Point",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "TVA_BS_LVL": {
      "id": "TVA_BS_LVL",
      "byteOffset": 64,
      "byteLength": 1,
      "description": "TVA:Bias level",
      "dataRange": [
        -10,
        10
      ],
      "initValue": 0
    },
    "TVA_LEVEL": {
      "id": "TVA_LEVEL",
      "byteOffset": 65,
      "byteLength": 1,
      "description": "TVA:Level",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "TVA_AFT": {
      "id": "TVA_AFT",
      "byteOffset": 66,
      "byteLength": 1,
      "description": "TVA After Touch Sens",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "TVA_LFO": {
      "id": "TVA_LFO",
      "byteOffset": 67,
      "byteLength": 1,
      "description": "TVA:LFO select",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "LFO1 ",
        "1": "LFO2"
      }
    },
    "TVA_LFO_DEP": {
      "id": "TVA_LFO_DEP",
      "byteOffset": 68,
      "byteLength": 1,
      "description": "TVA:LFO depth",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "AENV_VSENS": {
      "id": "AENV_VSENS",
      "byteOffset": 69,
      "byteLength": 1,
      "description": "A-ENV:Velo sens",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "AENV_T_VS": {
      "id": "AENV_T_VS",
      "byteOffset": 70,
      "byteLength": 1,
      "description": "A-ENV:T vsens",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "AENV_T_KF": {
      "id": "AENV_T_KF",
      "byteOffset": 71,
      "byteLength": 1,
      "description": "A-ENV:Time KF",
      "dataRange": [
        -10,
        10
      ],
      "initValue": 0
    },
    "AENV_L1": {
      "id": "AENV_L1",
      "byteOffset": 72,
      "byteLength": 1,
      "description": "A-ENV:Level 1",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "AENV_L2": {
      "id": "AENV_L2",
      "byteOffset": 73,
      "byteLength": 1,
      "description": "A-ENV:Level 2",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "AENV_SUS": {
      "id": "AENV_SUS",
      "byteOffset": 74,
      "byteLength": 1,
      "description": "A-ENV:Sus level",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "AENV_T1": {
      "id": "AENV_T1",
      "byteOffset": 75,
      "byteLength": 1,
      "description": "A-ENV:Time 1",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "AENV_T2": {
      "id": "AENV_T2",
      "byteOffset": 76,
      "byteLength": 1,
      "description": "A-ENV:Time 2",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "AENV_T3": {
      "id": "AENV_T3",
      "byteOffset": 77,
      "byteLength": 1,
      "description": "A-ENV:Time 3",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "AENV_T4": {
      "id": "AENV_T4",
      "byteOffset": 78,
      "byteLength": 1,
      "description": "A-ENV:Time 4",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 79,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MDLJPX_FENV"] = {
  "name": "MDLJPX_FENV",
  "description": "FENV",
  "byteLength": 12,
  "parameters": {
    "A": {
      "id": "A",
      "byteOffset": 0,
      "byteLength": 2,
      "description": "FILTER ENV01$ ATTACK",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "D": {
      "id": "D",
      "byteOffset": 2,
      "byteLength": 2,
      "description": "FILTER ENV01$ DECAY",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "S": {
      "id": "S",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "FILTER ENV01$ SUSTAIN",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    },
    "R": {
      "id": "R",
      "byteOffset": 6,
      "byteLength": 2,
      "description": "FILTER ENV01$ RELEASE",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "DEPTH": {
      "id": "DEPTH",
      "byteOffset": 8,
      "byteLength": 2,
      "description": "FILTER ENV01$ DEPTH",
      "dataRange": [
        -1023,
        1023
      ],
      "initValue": 0
    },
    "VSENS": {
      "id": "VSENS",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "FILTER ENV01$ VELOCITY SENS",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "KYBD": {
      "id": "KYBD",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "FILTER ENV01$ KEY FOLLOW",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MDLJPX_LFO"] = {
  "name": "MDLJPX_LFO",
  "description": "LFO",
  "byteLength": 16,
  "parameters": {
    "WAVE": {
      "id": "WAVE",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "LFO01$ WAVE FORM",
      "dataRange": [
        0,
        9
      ],
      "initValue": 0,
      "values": {
        "0": "SIN",
        "1": "TRI",
        "2": "SAW-UP",
        "3": "SAW-DW",
        "4": "SQR",
        "5": "RND",
        "6": "TRP",
        "7": "S&H",
        "8": "CHS",
        "9": "VSIN"
      }
    },
    "NOTE": {
      "id": "NOTE",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "LFO01$ RATE (Note)",
      "dataRange": [
        0,
        22
      ],
      "initValue": 9,
      "values": {
        "0": "1/64T",
        "1": "1/64",
        "2": "1/32T",
        "3": "1/32",
        "4": "1/16T",
        "5": "1/32.",
        "6": "1/16",
        "7": "1/8T",
        "8": "1/16.",
        "9": "1/8",
        "10": "1/4T",
        "11": "1/8.",
        "12": "1/4",
        "13": "1/2T",
        "14": "1/4.",
        "15": "1/2",
        "16": "1T",
        "17": "1/2.",
        "18": "1",
        "19": "2T",
        "20": "1.",
        "21": "2",
        "22": "4"
      }
    },
    "RATE": {
      "id": "RATE",
      "byteOffset": 2,
      "byteLength": 2,
      "description": "LFO01$ RATE",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 621
    },
    "DELAY": {
      "id": "DELAY",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "LFO01$ DELAY TIME",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "DEPTH_P": {
      "id": "DEPTH_P",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "LFO01$ PITCH DEPTH",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "DEPTH_F": {
      "id": "DEPTH_F",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "LFO01$ FILTER DEPTH",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "DEPTH_A": {
      "id": "DEPTH_A",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "LFO01$ AMP DEPTH",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "DEST_P": {
      "id": "DEST_P",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "LFO01$ PITCH DESTINATION SELECT",
      "dataRange": [
        0,
        6
      ],
      "initValue": 0,
      "values": {
        "0": "ALL",
        "1": "OSC1",
        "2": "OSC2",
        "3": "OSC3",
        "4": "OSC4",
        "5": "OSC12",
        "6": "OSC34"
      }
    },
    "SYNC": {
      "id": "SYNC",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "LFO01$ SYNC SWITCH",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "KEY_TRG": {
      "id": "KEY_TRG",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "LFO01$ KEY TRIGGER",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PAN_DEPTH": {
      "id": "PAN_DEPTH",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "LFO01$ PAN DEPTH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 13,
      "byteLength": 3,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MDLJPX_OSC"] = {
  "name": "MDLJPX_OSC",
  "description": "OSC",
  "byteLength": 12,
  "parameters": {
    "WAVE": {
      "id": "WAVE",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "OSC01$ WAVEFORM",
      "dataRange": [
        0,
        6
      ],
      "initValue": 0,
      "values": {
        "0": "SAW",
        "1": "SQR",
        "2": "TRI",
        "3": "SIN",
        "4": "JUNO",
        "5": "SUPSAW",
        "6": "NOISE"
      }
    },
    "COARSE": {
      "id": "COARSE",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "OSC01$ COARSE TUNE",
      "dataRange": [
        -24,
        24
      ],
      "initValue": 0
    },
    "FINE": {
      "id": "FINE",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "OSC01$ FINE TUNE",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "LEVEL": {
      "id": "LEVEL",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "OSC01$ LEVEL",
      "dataRange": [
        0,
        255
      ],
      "initValue": 255
    },
    "PW_PWM": {
      "id": "PW_PWM",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "OSC01$ PW PWM",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "PW_MODE": {
      "id": "PW_MODE",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "OSC01$ PW MODE",
      "dataRange": [
        0,
        3
      ],
      "initValue": 1,
      "values": {
        "0": "MANUAL",
        "1": "LFO2",
        "2": "P-ENV",
        "3": "F-ENV"
      }
    },
    "DELAY": {
      "id": "DELAY",
      "byteOffset": 6,
      "byteLength": 2,
      "description": "OSC01$ DELAY TIME",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "DELAY_SYNC": {
      "id": "DELAY_SYNC",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "OSC01$ DELAY TIME SYNC",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "DELAY_NOTE": {
      "id": "DELAY_NOTE",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "OSC01$ DELAY TIME (Note)",
      "dataRange": [
        0,
        21
      ],
      "initValue": 9,
      "values": {
        "0": "1/64T",
        "1": "1/64",
        "2": "1/32T",
        "3": "1/32",
        "4": "1/16T",
        "5": "1/32.",
        "6": "1/16",
        "7": "1/8T",
        "8": "1/16.",
        "9": "1/8",
        "10": "1/4T",
        "11": "1/8.",
        "12": "1/4",
        "13": "1/2T",
        "14": "1/4.",
        "15": "1/2",
        "16": "1T",
        "17": "1/2.",
        "18": "1",
        "19": "2T",
        "20": "1.",
        "21": "2"
      }
    },
    "PAN": {
      "id": "PAN",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "OSC01$ PAN",
      "dataRange": [
        -64,
        63
      ],
      "initValue": 0
    },
    "PAN_ALT": {
      "id": "PAN_ALT",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "OSC01$ ALTERNATE PAN DEPTH",
      "dataRange": [
        -64,
        63
      ],
      "initValue": 0
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MDLJPX_PENV"] = {
  "name": "MDLJPX_PENV",
  "description": "PENV",
  "byteLength": 12,
  "parameters": {
    "A": {
      "id": "A",
      "byteOffset": 0,
      "byteLength": 2,
      "description": "PITCH ENV01$ ATTACK",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "D": {
      "id": "D",
      "byteOffset": 2,
      "byteLength": 2,
      "description": "PITCH ENV01$ DECAY",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "S": {
      "id": "S",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "PITCH ENV01$ SUSTAIN",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    },
    "R": {
      "id": "R",
      "byteOffset": 6,
      "byteLength": 2,
      "description": "PITCH ENV01$ RELEASE",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "DEPTH": {
      "id": "DEPTH",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "PITCH ENV01$ DEPTH",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "VSENS": {
      "id": "VSENS",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "PITCH ENV01$ VELOCITY SENS",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "DEST": {
      "id": "DEST",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "PITCH ENV01$ DESTINATION SELECT",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "OSC1",
        "1": "BOTH",
        "2": "OSC2"
      }
    },
    "KYBD": {
      "id": "KYBD",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "PITCH ENV01$ KEY FOLLOW",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MDLJPX"] = {
  "name": "MDLJPX",
  "description": "JUPITER-X OSC Parameter",
  "byteLength": 108,
  "parameters": {
    "OSC": {
      "id": "OSC",
      "byteOffset": 0,
      "byteLength": 12,
      "description": "OSC",
      "blockName": "MDLJPX_OSC",
      "count": 1,
      "blockByteLength": 12,
      "block": ZenProperties["MDLJPX_OSC"]
    },
    "LFO": {
      "id": "LFO",
      "byteOffset": 12,
      "byteLength": 16,
      "description": "LFO",
      "blockName": "MDLJPX_LFO",
      "count": 1,
      "blockByteLength": 16,
      "block": ZenProperties["MDLJPX_LFO"]
    },
    "PENV": {
      "id": "PENV",
      "byteOffset": 28,
      "byteLength": 12,
      "description": "PENV",
      "blockName": "MDLJPX_PENV",
      "count": 1,
      "blockByteLength": 12,
      "block": ZenProperties["MDLJPX_PENV"]
    },
    "FENV": {
      "id": "FENV",
      "byteOffset": 40,
      "byteLength": 12,
      "description": "FENV",
      "blockName": "MDLJPX_FENV",
      "count": 1,
      "blockByteLength": 12,
      "block": ZenProperties["MDLJPX_FENV"]
    },
    "FLT_FREQ": {
      "id": "FLT_FREQ",
      "byteOffset": 52,
      "byteLength": 2,
      "description": "FILTER CUTOFF FREQ",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    },
    "FLT_RESO": {
      "id": "FLT_RESO",
      "byteOffset": 54,
      "byteLength": 2,
      "description": "FILTER RESONANCE",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "FLT_HPF": {
      "id": "FLT_HPF",
      "byteOffset": 56,
      "byteLength": 2,
      "description": "FILTER HPF",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "FLT_SLOPE": {
      "id": "FLT_SLOPE",
      "byteOffset": 58,
      "byteLength": 1,
      "description": "FILTER SLOPE",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "-12",
        "1": "-18",
        "2": "-24"
      }
    },
    "FLT_TYPE": {
      "id": "FLT_TYPE",
      "byteOffset": 59,
      "byteLength": 1,
      "description": "FILTER TYPE",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "R",
        "1": "M",
        "2": "S"
      }
    },
    "FLT_KYBD": {
      "id": "FLT_KYBD",
      "byteOffset": 60,
      "byteLength": 1,
      "description": "FILTER KEY FOLLOW",
      "dataRange": [
        0,
        200
      ],
      "initValue": 0
    },
    "FLT_VSENS": {
      "id": "FLT_VSENS",
      "byteOffset": 61,
      "byteLength": 1,
      "description": "FILTER VELOCITY SENS",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "AENV_A": {
      "id": "AENV_A",
      "byteOffset": 62,
      "byteLength": 2,
      "description": "AMP ENV ATTACK",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "AENV_D": {
      "id": "AENV_D",
      "byteOffset": 64,
      "byteLength": 2,
      "description": "AMP ENV DECAY",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "AENV_S": {
      "id": "AENV_S",
      "byteOffset": 66,
      "byteLength": 2,
      "description": "AMP ENV SUSTAIN",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    },
    "AENV_R": {
      "id": "AENV_R",
      "byteOffset": 68,
      "byteLength": 2,
      "description": "AMP ENV RELEASE",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "AENV_VSENS": {
      "id": "AENV_VSENS",
      "byteOffset": 70,
      "byteLength": 1,
      "description": "AMP ENV VELOCITY SENS",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "AENV_KYBD": {
      "id": "AENV_KYBD",
      "byteOffset": 71,
      "byteLength": 1,
      "description": "AMP ENV KEY FOLLOW",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "PENVLINK": {
      "id": "PENVLINK",
      "byteOffset": 78,
      "byteLength": 1,
      "description": "PITCH ENV1/2 LINK SWITCH",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "FENVLINK": {
      "id": "FENVLINK",
      "byteOffset": 79,
      "byteLength": 1,
      "description": "FILTER ENV1/2 LINK SWITCH",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "AMP_LEVEL": {
      "id": "AMP_LEVEL",
      "byteOffset": 80,
      "byteLength": 1,
      "description": "AMP LEVEL",
      "dataRange": [
        0,
        127
      ],
      "initValue": 96
    },
    "PTA_MODE": {
      "id": "PTA_MODE",
      "byteOffset": 83,
      "byteLength": 1,
      "description": "PORTAMENT MODE",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "NORMAL",
        "2": "LEGATO"
      }
    },
    "PTA_TIME": {
      "id": "PTA_TIME",
      "byteOffset": 84,
      "byteLength": 2,
      "description": "PORTAMENT TIME",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 180
    },
    "PTA_CRV": {
      "id": "PTA_CRV",
      "byteOffset": 86,
      "byteLength": 1,
      "description": "PORTAMENT CURVE TYPE",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "LIN",
        "1": "EXP"
      }
    },
    "AFT_LFO": {
      "id": "AFT_LFO",
      "byteOffset": 87,
      "byteLength": 1,
      "description": "AFTER TOUCH SENS LFO",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "AFT_FREQ": {
      "id": "AFT_FREQ",
      "byteOffset": 88,
      "byteLength": 1,
      "description": "AFTER TOUCH SENS FREQ",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 20
    },
    "AFT_LEV": {
      "id": "AFT_LEV",
      "byteOffset": 89,
      "byteLength": 1,
      "description": "AFTER TOUCH SENS LEVEL",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "AFT_PITCH": {
      "id": "AFT_PITCH",
      "byteOffset": 90,
      "byteLength": 1,
      "description": "AFTER TOUCH SENS PITCH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "BND_PTCH_UP": {
      "id": "BND_PTCH_UP",
      "byteOffset": 91,
      "byteLength": 1,
      "description": "BENDER PITCH DEPTH UP",
      "dataRange": [
        0,
        24
      ],
      "initValue": 2
    },
    "BND_PTCH_DW": {
      "id": "BND_PTCH_DW",
      "byteOffset": 92,
      "byteLength": 1,
      "description": "BENDER PITCH DEPTH DOWN",
      "dataRange": [
        0,
        24
      ],
      "initValue": 2
    },
    "BND_FLT": {
      "id": "BND_FLT",
      "byteOffset": 93,
      "byteLength": 1,
      "description": "BENDER FILTER DEPTH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "BND_LFO": {
      "id": "BND_LFO",
      "byteOffset": 94,
      "byteLength": 1,
      "description": "MODULATION LFO DEPTH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 14
    },
    "BND_LFO_RATE": {
      "id": "BND_LFO_RATE",
      "byteOffset": 95,
      "byteLength": 1,
      "description": "MODULATION LFO RATE SENS",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "KBDMODE": {
      "id": "KBDMODE",
      "byteOffset": 96,
      "byteLength": 1,
      "description": "KEY MODE",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "POLY",
        "1": "SOLO",
        "2": "UNISON",
        "3": "SL-UNISON"
      }
    },
    "PCHDRFT": {
      "id": "PCHDRFT",
      "byteOffset": 97,
      "byteLength": 1,
      "description": "PITCH DRIFT",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "UNISON_DETUNE": {
      "id": "UNISON_DETUNE",
      "byteOffset": 98,
      "byteLength": 1,
      "description": "UNISON DETUNE",
      "dataRange": [
        0,
        100
      ],
      "initValue": 20
    },
    "CONDITION": {
      "id": "CONDITION",
      "byteOffset": 99,
      "byteLength": 1,
      "description": "CONDITION",
      "dataRange": [
        0,
        100
      ],
      "initValue": 4
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 100,
      "byteLength": 8,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MDLSYN0"] = {
  "name": "MDLSYN0",
  "description": "Model Synth Parameter Interface type0",
  "byteLength": 112,
  "parameters": {
    "MODEL": {
      "id": "MODEL",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Model",
      "dataRange": [
        0,
        5
      ],
      "initValue": 0,
      "values": {
        "0": "---",
        "1": "JP8",
        "2": "JX8P",
        "3": "JUNO106",
        "4": "SH101",
        "5": "JUNO60"
      }
    },
    "LFOWAVE": {
      "id": "LFOWAVE",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "LFO WAVE FORM",
      "dataRange": [
        0,
        10
      ],
      "initValue": 0,
      "values": {
        "0": "SIN",
        "1": "TRI",
        "2": "SAW-UP",
        "3": "SAW-DW",
        "4": "SQR",
        "5": "RND",
        "6": "TRP",
        "7": "S&H",
        "8": "CHS",
        "9": "VSIN",
        "10": "STEP"
      }
    },
    "LFORATE": {
      "id": "LFORATE",
      "byteOffset": 2,
      "byteLength": 2,
      "description": "LFO RATE",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "LFODLY": {
      "id": "LFODLY",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "LFO DELAY TIME",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "OSC1MOD": {
      "id": "OSC1MOD",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "OSC1 MOD",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC1PENV": {
      "id": "OSC1PENV",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "OSC1 PITCH ENV DEPTH",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC1DEST": {
      "id": "OSC1DEST",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "OSC1 DEST SELECT",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "OSC1",
        "1": "BOTH",
        "2": "OSC2"
      }
    },
    "OSC1ENVS": {
      "id": "OSC1ENVS",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "OSC1 ENVT SELECT",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "1",
        "1": "2"
      }
    },
    "OSC1WAVE": {
      "id": "OSC1WAVE",
      "byteOffset": 10,
      "byteLength": 2,
      "description": "OSC1 WAVE FORM",
      "dataRange": [
        0,
        27
      ],
      "initValue": 0,
      "values": {
        "0": "PW",
        "1": "SAW",
        "2": "SUB1OCT1",
        "3": "SUB2OCT1",
        "4": "SUB2OCT2",
        "5": "NOISE",
        "6": "PW",
        "7": "SAW",
        "8": "SUB1OCT1",
        "9": "NOISE",
        "10": "SIN",
        "11": "TRI",
        "12": "SAW",
        "13": "PW",
        "14": "SQR",
        "15": "NOISE",
        "16": "SAW",
        "17": "PULSE",
        "18": "SQR",
        "19": "NOISE",
        "20": "TRI",
        "21": "SAW+TRI",
        "22": "SAW",
        "23": "SQR",
        "24": "SQR2",
        "25": "SQR3",
        "26": "WHITE NOISE",
        "27": "PINK NOISE"
      }
    },
    "OSC1FEET": {
      "id": "OSC1FEET",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "OSC1 FEET",
      "dataRange": [
        0,
        4
      ],
      "initValue": 0,
      "values": {
        "0": "32'",
        "1": "16'",
        "2": "8'",
        "3": "4'",
        "4": "2'"
      }
    },
    "OSC1COARSE": {
      "id": "OSC1COARSE",
      "byteOffset": 13,
      "byteLength": 1,
      "description": "OSC1 COARSE TUNE",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0
    },
    "OSC1FINE": {
      "id": "OSC1FINE",
      "byteOffset": 14,
      "byteLength": 1,
      "description": "OSC1 FINE TUNE",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "OSC1LOWFREQ": {
      "id": "OSC1LOWFREQ",
      "byteOffset": 15,
      "byteLength": 1,
      "description": "OSC1 LOW FREQ PITCH",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "OSC1MODE": {
      "id": "OSC1MODE",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "OSC1 MODE",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "NORMAL",
        "1": "LOW FREQ"
      }
    },
    "OSC1PWM": {
      "id": "OSC1PWM",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "OSC1 PWM DEPTH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "OSC1PLSW": {
      "id": "OSC1PLSW",
      "byteOffset": 18,
      "byteLength": 1,
      "description": "OSC1 PULSE WIDTH",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "OSC1PLSM": {
      "id": "OSC1PLSM",
      "byteOffset": 19,
      "byteLength": 1,
      "description": "OSC1 PULSE WIDTH MODE",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "LFO",
        "1": "MANUAL",
        "2": "ENV"
      }
    },
    "OSC2MOD": {
      "id": "OSC2MOD",
      "byteOffset": 20,
      "byteLength": 1,
      "description": "OSC2 MOD",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC2PENV": {
      "id": "OSC2PENV",
      "byteOffset": 21,
      "byteLength": 1,
      "description": "OSC2 PITCH ENV DEPTH",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC2WAVE": {
      "id": "OSC2WAVE",
      "byteOffset": 22,
      "byteLength": 2,
      "description": "OSC2 WAVE FORM",
      "dataRange": [
        0,
        27
      ],
      "initValue": 0,
      "values": {
        "0": "PW",
        "1": "SAW",
        "2": "SUB1OCT1",
        "3": "SUB2OCT1",
        "4": "SUB2OCT2",
        "5": "NOISE",
        "6": "PW",
        "7": "SAW",
        "8": "SUB1OCT1",
        "9": "NOISE",
        "10": "SIN",
        "11": "TRI",
        "12": "SAW",
        "13": "PW",
        "14": "SQR",
        "15": "NOISE",
        "16": "SAW",
        "17": "PULSE",
        "18": "SQR",
        "19": "NOISE",
        "20": "TRI",
        "21": "SAW+TRI",
        "22": "SAW",
        "23": "SQR",
        "24": "SQR2",
        "25": "SQR3",
        "26": "WHITE NOISE",
        "27": "PINK NOISE"
      }
    },
    "OSC2FEET": {
      "id": "OSC2FEET",
      "byteOffset": 24,
      "byteLength": 1,
      "description": "OSC2 FEET",
      "dataRange": [
        0,
        4
      ],
      "initValue": 0,
      "values": {
        "0": "32'",
        "1": "16'",
        "2": "8'",
        "3": "4'",
        "4": "2'"
      }
    },
    "OSC2COARSE": {
      "id": "OSC2COARSE",
      "byteOffset": 25,
      "byteLength": 1,
      "description": "OSC2 COARSE TUNE",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0
    },
    "OSC2FINE": {
      "id": "OSC2FINE",
      "byteOffset": 26,
      "byteLength": 1,
      "description": "OSC2 FINE TUNE",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "OSC2LOWFREQ": {
      "id": "OSC2LOWFREQ",
      "byteOffset": 27,
      "byteLength": 1,
      "description": "OSC2 LOW FREQ PITCH",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "OSC2MODE": {
      "id": "OSC2MODE",
      "byteOffset": 28,
      "byteLength": 1,
      "description": "OSC2 MODE",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "NORMAL",
        "1": "LO FREQ"
      }
    },
    "OSC2PW": {
      "id": "OSC2PW",
      "byteOffset": 29,
      "byteLength": 1,
      "description": "OSC2 PULSE WIDTH",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "OSC3MOD": {
      "id": "OSC3MOD",
      "byteOffset": 30,
      "byteLength": 1,
      "description": "OSC3 MOD",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC3PENV": {
      "id": "OSC3PENV",
      "byteOffset": 31,
      "byteLength": 1,
      "description": "OSC3 PITCH ENV DEPTH",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "OSC3WAVE": {
      "id": "OSC3WAVE",
      "byteOffset": 32,
      "byteLength": 2,
      "description": "OSC3 WAVE FORM",
      "dataRange": [
        0,
        27
      ],
      "initValue": 0,
      "values": {
        "0": "PW",
        "1": "SAW",
        "2": "SQR 1OCT",
        "3": "SQR 2OCT",
        "4": "SH SubOSC",
        "5": "NOISE",
        "6": "PW",
        "7": "SAW",
        "8": "SQR 1OCT",
        "9": "NOISE",
        "10": "SIN",
        "11": "TRI",
        "12": "SAW",
        "13": "PW",
        "14": "SQR",
        "15": "NOISE",
        "16": "SAW",
        "17": "PULSE",
        "18": "SQR",
        "19": "NOISE",
        "20": "TRI",
        "21": "SAW+TRI",
        "22": "SAW",
        "23": "SQR",
        "24": "SQR2",
        "25": "SQR3",
        "26": "WHITE NOISE",
        "27": "PINK NOISE"
      }
    },
    "OSC3FEET": {
      "id": "OSC3FEET",
      "byteOffset": 34,
      "byteLength": 1,
      "description": "OSC3 FEET",
      "dataRange": [
        0,
        4
      ],
      "initValue": 0,
      "values": {
        "0": "32'",
        "1": "16'",
        "2": "8'",
        "3": "4'",
        "4": "2'"
      }
    },
    "OSC3COARSE": {
      "id": "OSC3COARSE",
      "byteOffset": 35,
      "byteLength": 1,
      "description": "OSC3 COARSE TUNE",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0
    },
    "OSC3FINE": {
      "id": "OSC3FINE",
      "byteOffset": 36,
      "byteLength": 1,
      "description": "OSC3 FINE TUNE",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "OSC3LOWFREQ": {
      "id": "OSC3LOWFREQ",
      "byteOffset": 37,
      "byteLength": 1,
      "description": "OSC3 LOW FREQ PITCH",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "OSC3MODE": {
      "id": "OSC3MODE",
      "byteOffset": 38,
      "byteLength": 1,
      "description": "OSC3 MODE",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "NORMAL",
        "1": "LO FREQ"
      }
    },
    "NOISE": {
      "id": "NOISE",
      "byteOffset": 39,
      "byteLength": 1,
      "description": "NOISE",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "WHITE",
        "1": "PINK"
      }
    },
    "MODDPTH": {
      "id": "MODDPTH",
      "byteOffset": 40,
      "byteLength": 2,
      "description": "MOD DEPTH",
      "dataRange": [
        0,
        10800
      ],
      "initValue": 0
    },
    "MODMODE": {
      "id": "MODMODE",
      "byteOffset": 42,
      "byteLength": 1,
      "description": "MOD MODE",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "SYNC",
        "2": "RING",
        "3": "X-MOD"
      }
    },
    "MXROSC1": {
      "id": "MXROSC1",
      "byteOffset": 43,
      "byteLength": 1,
      "description": "OSC1 LEVEL",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "MXROSC2": {
      "id": "MXROSC2",
      "byteOffset": 44,
      "byteLength": 1,
      "description": "OSC2 LEVEL",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "MXROSC3": {
      "id": "MXROSC3",
      "byteOffset": 45,
      "byteLength": 1,
      "description": "OSC3 LEVEL",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "MXRNOISE": {
      "id": "MXRNOISE",
      "byteOffset": 46,
      "byteLength": 1,
      "description": "NOISE LEVEL",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "MXRENVD": {
      "id": "MXRENVD",
      "byteOffset": 47,
      "byteLength": 1,
      "description": "MIXER ENV DEPTH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "MXRENVS": {
      "id": "MXRENVS",
      "byteOffset": 48,
      "byteLength": 1,
      "description": "MIXER ENV SELECT",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "1",
        "1": "2"
      }
    },
    "MXRDYNA": {
      "id": "MXRDYNA",
      "byteOffset": 49,
      "byteLength": 1,
      "description": "MIXER DYNAMICS",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "FLTTYPE": {
      "id": "FLTTYPE",
      "byteOffset": 50,
      "byteLength": 1,
      "description": "FILTER TYPE",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "FLTHPF2": {
      "id": "FLTHPF2",
      "byteOffset": 51,
      "byteLength": 1,
      "description": "FILTER HPF STEP",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "FLTHPF1": {
      "id": "FLTHPF1",
      "byteOffset": 52,
      "byteLength": 2,
      "description": "FILTER HPF",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "FLTFREQ": {
      "id": "FLTFREQ",
      "byteOffset": 54,
      "byteLength": 2,
      "description": "FILTER FREQ",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "FLTRESO": {
      "id": "FLTRESO",
      "byteOffset": 56,
      "byteLength": 2,
      "description": "FILTER RESO",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "FLTENVD": {
      "id": "FLTENVD",
      "byteOffset": 58,
      "byteLength": 2,
      "description": "FILTER ENV DEPTH",
      "dataRange": [
        -1023,
        1023
      ],
      "initValue": 0
    },
    "FLTENVS": {
      "id": "FLTENVS",
      "byteOffset": 60,
      "byteLength": 1,
      "description": "FILTER ENV SELECT",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "1",
        "1": "2"
      }
    },
    "FLTSLOPE": {
      "id": "FLTSLOPE",
      "byteOffset": 61,
      "byteLength": 1,
      "description": "FILTER SLOPE",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "-12dB",
        "1": "-18db",
        "2": "-24dB"
      }
    },
    "FLTKYBD": {
      "id": "FLTKYBD",
      "byteOffset": 62,
      "byteLength": 2,
      "description": "FILTER KEY FOLLOW",
      "dataRange": [
        -200,
        200
      ],
      "initValue": 0
    },
    "FLTMOD": {
      "id": "FLTMOD",
      "byteOffset": 64,
      "byteLength": 1,
      "description": "FILTER MOD",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 65,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "AMPLVL": {
      "id": "AMPLVL",
      "byteOffset": 66,
      "byteLength": 1,
      "description": "AMP LEVEL",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "AMPMOD1": {
      "id": "AMPMOD1",
      "byteOffset": 67,
      "byteLength": 1,
      "description": "AMP MOD",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "AMPMOD2": {
      "id": "AMPMOD2",
      "byteOffset": 68,
      "byteLength": 1,
      "description": "AMP MOD STEP",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "AMPENVS": {
      "id": "AMPENVS",
      "byteOffset": 69,
      "byteLength": 1,
      "description": "AMP ENV SELECT",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "ENV F&A",
        "1": "ENV2",
        "2": "G-AMP",
        "3": "G-ENV2"
      }
    },
    "ENV1A": {
      "id": "ENV1A",
      "byteOffset": 70,
      "byteLength": 2,
      "description": "ENV1 ATTACK",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV1D": {
      "id": "ENV1D",
      "byteOffset": 72,
      "byteLength": 2,
      "description": "ENV1 DECAY",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV1S": {
      "id": "ENV1S",
      "byteOffset": 74,
      "byteLength": 2,
      "description": "ENV1 SUSTAIN",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV1R": {
      "id": "ENV1R",
      "byteOffset": 76,
      "byteLength": 2,
      "description": "ENV1 RELEASE",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV1KYBD1": {
      "id": "ENV1KYBD1",
      "byteOffset": 78,
      "byteLength": 1,
      "description": "ENV1 KEY FOLLOW",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "ENV1KYBD2": {
      "id": "ENV1KYBD2",
      "byteOffset": 79,
      "byteLength": 1,
      "description": "ENV1 KEY FOLLOW STEP",
      "dataRange": [
        0,
        6
      ],
      "initValue": 0
    },
    "ENV2A": {
      "id": "ENV2A",
      "byteOffset": 80,
      "byteLength": 2,
      "description": "ENV2 ATTACK",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV2D": {
      "id": "ENV2D",
      "byteOffset": 82,
      "byteLength": 2,
      "description": "ENV2 DECAY",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV2S": {
      "id": "ENV2S",
      "byteOffset": 84,
      "byteLength": 2,
      "description": "ENV2 SUSTAIN",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV2R": {
      "id": "ENV2R",
      "byteOffset": 86,
      "byteLength": 2,
      "description": "ENV2 RELEASE",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "ENV2MODE": {
      "id": "ENV2MODE",
      "byteOffset": 88,
      "byteLength": 1,
      "description": "ENV2 MODE",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "GATE+TRIG",
        "1": "GATE",
        "2": "LFO"
      }
    },
    "ENV2KYBD1": {
      "id": "ENV2KYBD1",
      "byteOffset": 89,
      "byteLength": 1,
      "description": "ENV2 KEY FOLLOW",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "ENV2KYBD2": {
      "id": "ENV2KYBD2",
      "byteOffset": 90,
      "byteLength": 1,
      "description": "ENV2 KEY FOLLOW STEP",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "DYNPTCH": {
      "id": "DYNPTCH",
      "byteOffset": 91,
      "byteLength": 1,
      "description": "DYNAMICS PITCH",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "DYNFLTT": {
      "id": "DYNFLTT",
      "byteOffset": 92,
      "byteLength": 1,
      "description": "DYNAMICS FILTER",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "DYNAMP": {
      "id": "DYNAMP",
      "byteOffset": 93,
      "byteLength": 1,
      "description": "DYNAMICS AMP",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "PCHDRFT": {
      "id": "PCHDRFT",
      "byteOffset": 94,
      "byteLength": 1,
      "description": "PITCH DRIFT",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "BNDPTCH2": {
      "id": "BNDPTCH2",
      "byteOffset": 95,
      "byteLength": 1,
      "description": "BENDER PITCH DEPTH STEP",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "2",
        "1": "3",
        "2": "4",
        "3": "7"
      }
    },
    "BNDFLT": {
      "id": "BNDFLT",
      "byteOffset": 96,
      "byteLength": 1,
      "description": "BENDER FILTER DEPTH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "BNDLFO": {
      "id": "BNDLFO",
      "byteOffset": 97,
      "byteLength": 1,
      "description": "MODULATION LFO DEPTH",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "BNDPTCH1": {
      "id": "BNDPTCH1",
      "byteOffset": 98,
      "byteLength": 2,
      "description": "BENDER PITCH DEPTH",
      "dataRange": [
        0,
        4800
      ],
      "initValue": 0
    },
    "PTATIME": {
      "id": "PTATIME",
      "byteOffset": 100,
      "byteLength": 2,
      "description": "PORTAMENT TIME",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "PTAMODE": {
      "id": "PTAMODE",
      "byteOffset": 102,
      "byteLength": 1,
      "description": "PORTAMENT MODE",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON",
        "2": "AUTO"
      }
    },
    "KBDMODE": {
      "id": "KBDMODE",
      "byteOffset": 103,
      "byteLength": 1,
      "description": "KEY MODE",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "POLY",
        "1": "SOLO",
        "2": "UNISON",
        "3": "SL-UNISON"
      }
    },
    "EXPAND": {
      "id": "EXPAND",
      "byteOffset": 104,
      "byteLength": 1,
      "description": "PARAMETER EXPANSION SWITCH",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "CONDITION": {
      "id": "CONDITION",
      "byteOffset": 105,
      "byteLength": 1,
      "description": "CONDITION",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "PTACRV": {
      "id": "PTACRV",
      "byteOffset": 106,
      "byteLength": 1,
      "description": "PORTAMENT CURVE TYPE",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "ORIGINAL",
        "1": "LINER",
        "2": "EXP1",
        "3": "EXP2"
      }
    },
    "AFT_LFO": {
      "id": "AFT_LFO",
      "byteOffset": 107,
      "byteLength": 1,
      "description": "AFTER TOUCH SENS LFO",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "AFT_FREQ": {
      "id": "AFT_FREQ",
      "byteOffset": 108,
      "byteLength": 1,
      "description": "AFTER TOUCH SENS FREQ",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "AFT_LEV": {
      "id": "AFT_LEV",
      "byteOffset": 109,
      "byteLength": 1,
      "description": "AFTER TOUCH SENS LEVEL",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "PADDING2": {
      "id": "PADDING2",
      "byteOffset": 110,
      "byteLength": 2,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MDLVDN"] = {
  "name": "MDLVDN",
  "description": "Vocal Designer Model",
  "byteLength": 32,
  "parameters": {
    "MSTR_LVL": {
      "id": "MSTR_LVL",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 100
    },
    "MIC_LVL": {
      "id": "MIC_LVL",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "Mic Direct Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "VOC_LVL": {
      "id": "VOC_LVL",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "Vocoder Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 100
    },
    "ALGO": {
      "id": "ALGO",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "Algorithm",
      "dataRange": [
        0,
        25
      ],
      "initValue": 0,
      "values": {
        "0": "Classic A",
        "1": "Classic B",
        "2": "Classic C",
        "3": "Male&Fem 1",
        "4": "Male&Fem 2",
        "5": "Gospel A",
        "6": "Gospel B",
        "7": "Gospel C",
        "8": "Pop A",
        "9": "Pop B",
        "10": "Pop C",
        "11": "BackGround 1",
        "12": "BackGround 2",
        "13": "BackGround 3",
        "14": "BackGround 4",
        "15": "BackGround 5",
        "16": "Modern Voc 1",
        "17": "Modern Voc 2",
        "18": "Modern Voc 3",
        "19": "Vocoder 1",
        "20": "Vocoder 2",
        "21": "Vintage 1",
        "22": "Vintage 2",
        "23": "WahVox(KBD)",
        "24": "WahVox(VEXP)",
        "25": "WahVox(CTRL)"
      }
    },
    "CRR_TYPE": {
      "id": "CRR_TYPE",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "Carrier Type",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "Basic",
        "1": "Custom"
      }
    },
    "RSV_CRR_BASIC": {
      "id": "RSV_CRR_BASIC",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "Reserved",
      "dataRange": [
        0,
        0
      ],
      "initValue": 0
    },
    "LEVEL": {
      "id": "LEVEL",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "Carrier Basic Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 100
    },
    "PAN": {
      "id": "PAN",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "Carrier Basic Pan",
      "dataRange": [
        -64,
        63
      ],
      "initValue": 0
    },
    "PIT_CRS": {
      "id": "PIT_CRS",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "Carrier Basic Coarse Tune",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0
    },
    "PIT_FINE": {
      "id": "PIT_FINE",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "Carrier Basic Fine Tune",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0
    },
    "OCTAVE": {
      "id": "OCTAVE",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "Carrier Basic Octave Shift",
      "dataRange": [
        -2,
        2
      ],
      "initValue": 0
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 11,
      "byteLength": 21,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["MFX"] = {
  "name": "MFX",
  "description": "",
  "byteLength": 84,
  "parameters": {
    "mfxType": {
      "id": "mfxType",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Type",
      "dataRange": [
        0,
        93
      ],
      "initValue": 0
    },
    "mfxSwitch": {
      "id": "mfxSwitch",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "MFX Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1
    },
    "choSend": {
      "id": "choSend",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "MFX Chorus Send Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "revSend": {
      "id": "revSend",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "MFX Reverb Send Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "ctrlSrc1": {
      "id": "ctrlSrc1",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "MFX CtrlSrc 1",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "MOD:CC01",
        "2": "BRETH:CC02",
        "3": "CC03",
        "4": "FOOT:CC04",
        "5": "PTIME:CC05",
        "6": "DENT:CC06",
        "7": "VOL:CC07",
        "8": "BAL:CC08",
        "9": "CC09",
        "10": "PAN:CC10",
        "11": "EXP:CC11",
        "12": "CC12",
        "13": "CC13",
        "14": "CC14",
        "15": "CC15",
        "16": "GEN-1:CC16",
        "17": "GEN-2:CC17",
        "18": "GEN-3:CC18",
        "19": "GEN-4:CC19",
        "20": "CC20",
        "21": "CC21",
        "22": "CC22",
        "23": "CC23",
        "24": "CC24",
        "25": "CC25",
        "26": "CC26",
        "27": "CC27",
        "28": "CC28",
        "29": "CC29",
        "30": "CC30",
        "31": "CC31",
        "32": "CC33",
        "33": "CC34",
        "34": "CC35",
        "35": "CC36",
        "36": "CC37",
        "37": "DENT:CC38",
        "38": "CC39",
        "39": "CC40",
        "40": "CC41",
        "41": "CC42",
        "42": "CC43",
        "43": "CC44",
        "44": "CC45",
        "45": "CC46",
        "46": "CC47",
        "47": "CC48",
        "48": "CC49",
        "49": "CC50",
        "50": "CC51",
        "51": "CC52",
        "52": "CC53",
        "53": "CC54",
        "54": "CC55",
        "55": "CC56",
        "56": "CC57",
        "57": "CC58",
        "58": "CC59",
        "59": "CC60",
        "60": "CC61",
        "61": "CC62",
        "62": "CC63",
        "63": "HOLD1:CC64",
        "64": "PORTA:CC65",
        "65": "SOSTE:CC66",
        "66": "SOFT:CC67",
        "67": "LEGAT:CC68",
        "68": "HOLD2:CC69",
        "69": "CC70",
        "70": "RESO:CC71",
        "71": "RELES:CC72",
        "72": "ATTAK:CC73",
        "73": "CUTOF:CC74",
        "74": "DECAY:CC75",
        "75": "VRATE:CC76",
        "76": "VDPTH:CC77",
        "77": "VDLY:CC78",
        "78": "CC79",
        "79": "GEN-5:CC80",
        "80": "GEN-6:CC81",
        "81": "GEN-7:CC82",
        "82": "GEN-8:CC83",
        "83": "PCTRL:CC84",
        "84": "CC85",
        "85": "CC86",
        "86": "CC87",
        "87": "CC88",
        "88": "CC89",
        "89": "CC90",
        "90": "REV:CC91",
        "91": "TREM:CC92",
        "92": "CHO:CC93",
        "93": "CELST:CC94",
        "94": "PHASR:CC95",
        "95": "BEND",
        "96": "AFT",
        "97": "SYS-CTRL1",
        "98": "SYS-CTRL2",
        "99": "SYS-CTRL3",
        "100": "SYS-CTRL4"
      }
    },
    "ctrlSens1": {
      "id": "ctrlSens1",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "MFX CtrlSens 1",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "ctrlSrc2": {
      "id": "ctrlSrc2",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "MFX CtrlSrc 2",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "MOD:CC01",
        "2": "BRETH:CC02",
        "3": "CC03",
        "4": "FOOT:CC04",
        "5": "PTIME:CC05",
        "6": "DENT:CC06",
        "7": "VOL:CC07",
        "8": "BAL:CC08",
        "9": "CC09",
        "10": "PAN:CC10",
        "11": "EXP:CC11",
        "12": "CC12",
        "13": "CC13",
        "14": "CC14",
        "15": "CC15",
        "16": "GEN-1:CC16",
        "17": "GEN-2:CC17",
        "18": "GEN-3:CC18",
        "19": "GEN-4:CC19",
        "20": "CC20",
        "21": "CC21",
        "22": "CC22",
        "23": "CC23",
        "24": "CC24",
        "25": "CC25",
        "26": "CC26",
        "27": "CC27",
        "28": "CC28",
        "29": "CC29",
        "30": "CC30",
        "31": "CC31",
        "32": "CC33",
        "33": "CC34",
        "34": "CC35",
        "35": "CC36",
        "36": "CC37",
        "37": "DENT:CC38",
        "38": "CC39",
        "39": "CC40",
        "40": "CC41",
        "41": "CC42",
        "42": "CC43",
        "43": "CC44",
        "44": "CC45",
        "45": "CC46",
        "46": "CC47",
        "47": "CC48",
        "48": "CC49",
        "49": "CC50",
        "50": "CC51",
        "51": "CC52",
        "52": "CC53",
        "53": "CC54",
        "54": "CC55",
        "55": "CC56",
        "56": "CC57",
        "57": "CC58",
        "58": "CC59",
        "59": "CC60",
        "60": "CC61",
        "61": "CC62",
        "62": "CC63",
        "63": "HOLD1:CC64",
        "64": "PORTA:CC65",
        "65": "SOSTE:CC66",
        "66": "SOFT:CC67",
        "67": "LEGAT:CC68",
        "68": "HOLD2:CC69",
        "69": "CC70",
        "70": "RESO:CC71",
        "71": "RELES:CC72",
        "72": "ATTAK:CC73",
        "73": "CUTOF:CC74",
        "74": "DECAY:CC75",
        "75": "VRATE:CC76",
        "76": "VDPTH:CC77",
        "77": "VDLY:CC78",
        "78": "CC79",
        "79": "GEN-5:CC80",
        "80": "GEN-6:CC81",
        "81": "GEN-7:CC82",
        "82": "GEN-8:CC83",
        "83": "PCTRL:CC84",
        "84": "CC85",
        "85": "CC86",
        "86": "CC87",
        "87": "CC88",
        "88": "CC89",
        "89": "CC90",
        "90": "REV:CC91",
        "91": "TREM:CC92",
        "92": "CHO:CC93",
        "93": "CELST:CC94",
        "94": "PHASR:CC95",
        "95": "BEND",
        "96": "AFT",
        "97": "SYS-CTRL1",
        "98": "SYS-CTRL2",
        "99": "SYS-CTRL3",
        "100": "SYS-CTRL4"
      }
    },
    "ctrlSens2": {
      "id": "ctrlSens2",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "MFX CtrlSens 2",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "ctrlSrc3": {
      "id": "ctrlSrc3",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "MFX CtrlSrc 3",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "MOD:CC01",
        "2": "BRETH:CC02",
        "3": "CC03",
        "4": "FOOT:CC04",
        "5": "PTIME:CC05",
        "6": "DENT:CC06",
        "7": "VOL:CC07",
        "8": "BAL:CC08",
        "9": "CC09",
        "10": "PAN:CC10",
        "11": "EXP:CC11",
        "12": "CC12",
        "13": "CC13",
        "14": "CC14",
        "15": "CC15",
        "16": "GEN-1:CC16",
        "17": "GEN-2:CC17",
        "18": "GEN-3:CC18",
        "19": "GEN-4:CC19",
        "20": "CC20",
        "21": "CC21",
        "22": "CC22",
        "23": "CC23",
        "24": "CC24",
        "25": "CC25",
        "26": "CC26",
        "27": "CC27",
        "28": "CC28",
        "29": "CC29",
        "30": "CC30",
        "31": "CC31",
        "32": "CC33",
        "33": "CC34",
        "34": "CC35",
        "35": "CC36",
        "36": "CC37",
        "37": "DENT:CC38",
        "38": "CC39",
        "39": "CC40",
        "40": "CC41",
        "41": "CC42",
        "42": "CC43",
        "43": "CC44",
        "44": "CC45",
        "45": "CC46",
        "46": "CC47",
        "47": "CC48",
        "48": "CC49",
        "49": "CC50",
        "50": "CC51",
        "51": "CC52",
        "52": "CC53",
        "53": "CC54",
        "54": "CC55",
        "55": "CC56",
        "56": "CC57",
        "57": "CC58",
        "58": "CC59",
        "59": "CC60",
        "60": "CC61",
        "61": "CC62",
        "62": "CC63",
        "63": "HOLD1:CC64",
        "64": "PORTA:CC65",
        "65": "SOSTE:CC66",
        "66": "SOFT:CC67",
        "67": "LEGAT:CC68",
        "68": "HOLD2:CC69",
        "69": "CC70",
        "70": "RESO:CC71",
        "71": "RELES:CC72",
        "72": "ATTAK:CC73",
        "73": "CUTOF:CC74",
        "74": "DECAY:CC75",
        "75": "VRATE:CC76",
        "76": "VDPTH:CC77",
        "77": "VDLY:CC78",
        "78": "CC79",
        "79": "GEN-5:CC80",
        "80": "GEN-6:CC81",
        "81": "GEN-7:CC82",
        "82": "GEN-8:CC83",
        "83": "PCTRL:CC84",
        "84": "CC85",
        "85": "CC86",
        "86": "CC87",
        "87": "CC88",
        "88": "CC89",
        "89": "CC90",
        "90": "REV:CC91",
        "91": "TREM:CC92",
        "92": "CHO:CC93",
        "93": "CELST:CC94",
        "94": "PHASR:CC95",
        "95": "BEND",
        "96": "AFT",
        "97": "SYS-CTRL1",
        "98": "SYS-CTRL2",
        "99": "SYS-CTRL3",
        "100": "SYS-CTRL4"
      }
    },
    "ctrlSens3": {
      "id": "ctrlSens3",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "MFX CtrlSens 3",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "ctrlSrc4": {
      "id": "ctrlSrc4",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "MFX CtrlSrc 4",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "MOD:CC01",
        "2": "BRETH:CC02",
        "3": "CC03",
        "4": "FOOT:CC04",
        "5": "PTIME:CC05",
        "6": "DENT:CC06",
        "7": "VOL:CC07",
        "8": "BAL:CC08",
        "9": "CC09",
        "10": "PAN:CC10",
        "11": "EXP:CC11",
        "12": "CC12",
        "13": "CC13",
        "14": "CC14",
        "15": "CC15",
        "16": "GEN-1:CC16",
        "17": "GEN-2:CC17",
        "18": "GEN-3:CC18",
        "19": "GEN-4:CC19",
        "20": "CC20",
        "21": "CC21",
        "22": "CC22",
        "23": "CC23",
        "24": "CC24",
        "25": "CC25",
        "26": "CC26",
        "27": "CC27",
        "28": "CC28",
        "29": "CC29",
        "30": "CC30",
        "31": "CC31",
        "32": "CC33",
        "33": "CC34",
        "34": "CC35",
        "35": "CC36",
        "36": "CC37",
        "37": "DENT:CC38",
        "38": "CC39",
        "39": "CC40",
        "40": "CC41",
        "41": "CC42",
        "42": "CC43",
        "43": "CC44",
        "44": "CC45",
        "45": "CC46",
        "46": "CC47",
        "47": "CC48",
        "48": "CC49",
        "49": "CC50",
        "50": "CC51",
        "51": "CC52",
        "52": "CC53",
        "53": "CC54",
        "54": "CC55",
        "55": "CC56",
        "56": "CC57",
        "57": "CC58",
        "58": "CC59",
        "59": "CC60",
        "60": "CC61",
        "61": "CC62",
        "62": "CC63",
        "63": "HOLD1:CC64",
        "64": "PORTA:CC65",
        "65": "SOSTE:CC66",
        "66": "SOFT:CC67",
        "67": "LEGAT:CC68",
        "68": "HOLD2:CC69",
        "69": "CC70",
        "70": "RESO:CC71",
        "71": "RELES:CC72",
        "72": "ATTAK:CC73",
        "73": "CUTOF:CC74",
        "74": "DECAY:CC75",
        "75": "VRATE:CC76",
        "76": "VDPTH:CC77",
        "77": "VDLY:CC78",
        "78": "CC79",
        "79": "GEN-5:CC80",
        "80": "GEN-6:CC81",
        "81": "GEN-7:CC82",
        "82": "GEN-8:CC83",
        "83": "PCTRL:CC84",
        "84": "CC85",
        "85": "CC86",
        "86": "CC87",
        "87": "CC88",
        "88": "CC89",
        "89": "CC90",
        "90": "REV:CC91",
        "91": "TREM:CC92",
        "92": "CHO:CC93",
        "93": "CELST:CC94",
        "94": "PHASR:CC95",
        "95": "BEND",
        "96": "AFT",
        "97": "SYS-CTRL1",
        "98": "SYS-CTRL2",
        "99": "SYS-CTRL3",
        "100": "SYS-CTRL4"
      }
    },
    "ctrlSens4": {
      "id": "ctrlSens4",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "MFX CtrlSens 4",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "ctrlAsgn_1": {
      "id": "ctrlAsgn_1",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "MFX CtrlAsgn 1",
      "dataRange": [
        0,
        11
      ],
      "initValue": 0
    },
    "param_1": {
      "id": "param_1",
      "byteOffset": 16,
      "byteLength": 2,
      "description": "MFX Parameter 1",
      "dataRange": [
        -20000,
        20000
      ],
      "initValue": 0
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 80,
      "byteLength": 4,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMR_CMN"] = {
  "name": "PCMR_CMN",
  "description": "PCMRhythm Common",
  "byteLength": 28,
  "parameters": {
    "NAME_1": {
      "id": "NAME_1",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Name 1",
      "dataRange": [
        32,
        127
      ],
      "initValue": 32,
      "displayMeasurement": "ASCII"
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 16,
      "byteLength": 2,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "PHRASE": {
      "id": "PHRASE",
      "byteOffset": 18,
      "byteLength": 2,
      "description": "Phrase Number",
      "dataRange": [
        0,
        65535
      ],
      "initValue": 0
    },
    "LEVEL": {
      "id": "LEVEL",
      "byteOffset": 20,
      "byteLength": 1,
      "description": "Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "PADDING2": {
      "id": "PADDING2",
      "byteOffset": 21,
      "byteLength": 2,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "PHRASE_VEL_RATE": {
      "id": "PHRASE_VEL_RATE",
      "byteOffset": 23,
      "byteLength": 1,
      "description": "Phrase Velo Rate",
      "dataRange": [
        1,
        200
      ],
      "initValue": 100
    },
    "PHRASE_VEL_SHIFT": {
      "id": "PHRASE_VEL_SHIFT",
      "byteOffset": 24,
      "byteLength": 1,
      "description": "Phrase Velo Shift",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "PADDING3": {
      "id": "PADDING3",
      "byteOffset": 25,
      "byteLength": 3,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMR_PTL"] = {
  "name": "PCMR_PTL",
  "description": "PCMRhythm Partial",
  "byteLength": 20,
  "parameters": {
    "INST_NUM": {
      "id": "INST_NUM",
      "byteOffset": 0,
      "byteLength": 2,
      "description": "Inst Number",
      "dataRange": [
        0,
        32768
      ],
      "initValue": 0
    },
    "INST_GTYPE": {
      "id": "INST_GTYPE",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "Inst Bank",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "values": {
        "0": "PRESET",
        "1": "USER",
        "2": "EXP"
      }
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "INST_GID": {
      "id": "INST_GID",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "Inst Group ID",
      "dataRange": [
        0,
        16383
      ],
      "initValue": 0
    },
    "LEVEL": {
      "id": "LEVEL",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "PADDING2": {
      "id": "PADDING2",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "PAN": {
      "id": "PAN",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "Pan",
      "dataRange": [
        -64,
        63
      ],
      "initValue": 0
    },
    "CHO_SEND": {
      "id": "CHO_SEND",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "Chorus Send Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "REV_SEND": {
      "id": "REV_SEND",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "Reverb Send Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "MUTE_GRP": {
      "id": "MUTE_GRP",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "Mute Group",
      "dataRange": [
        0,
        31
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        "11": "11",
        "12": "12",
        "13": "13",
        "14": "14",
        "15": "15",
        "16": "16",
        "17": "17",
        "18": "18",
        "19": "19",
        "20": "20",
        "21": "21",
        "22": "22",
        "23": "23",
        "24": "24",
        "25": "25",
        "26": "26",
        "27": "27",
        "28": "28",
        "29": "29",
        "30": "30",
        "31": "31"
      }
    },
    "OUT_ASGN": {
      "id": "OUT_ASGN",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "Output Assign",
      "dataRange": [
        0,
        7
      ],
      "initValue": 1,
      "values": {
        "0": "DRY",
        "1": "MFX",
        "2": "COMP1",
        "3": "COMP2",
        "4": "COMP3",
        "5": "COMP4",
        "6": "COMP5",
        "7": "COMP6"
      }
    },
    "KEY_OFST": {
      "id": "KEY_OFST",
      "byteOffset": 13,
      "byteLength": 1,
      "description": "Key Offset",
      "dataRange": [
        -24,
        24
      ],
      "initValue": 0
    },
    "PIT_FINE_OFST": {
      "id": "PIT_FINE_OFST",
      "byteOffset": 14,
      "byteLength": 1,
      "description": "Fine Tune Offset",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0,
      "displayMeasurement": "cent"
    },
    "CUTOFF_OFST": {
      "id": "CUTOFF_OFST",
      "byteOffset": 15,
      "byteLength": 1,
      "description": "TVF Cutoff Offset",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "RESO_OFST": {
      "id": "RESO_OFST",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "TVF Resonance Offset",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "TVA_ATK_OFST": {
      "id": "TVA_ATK_OFST",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "TVA Attack Time Offset",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "TVA_DCY_OFST": {
      "id": "TVA_DCY_OFST",
      "byteOffset": 18,
      "byteLength": 1,
      "description": "TVA Decay Time Offset",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "TVA_REL_OFST": {
      "id": "TVA_REL_OFST",
      "byteOffset": 19,
      "byteLength": 1,
      "description": "TVA Release Time Offset",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMS_CMN"] = {
  "name": "PCMS_CMN",
  "description": "PCMSynth Common",
  "byteLength": 20,
  "parameters": {
    "UNISON_SW": {
      "id": "UNISON_SW",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Unison Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "UNISON_SIZE": {
      "id": "UNISON_SIZE",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "Unison Size",
      "dataRange": [
        2,
        8
      ],
      "initValue": 4
    },
    "UNISON_DETN": {
      "id": "UNISON_DETN",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "Unison Detune",
      "dataRange": [
        0,
        100
      ],
      "initValue": 20
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "BEND_RANGE_FINE_UP": {
      "id": "BEND_RANGE_FINE_UP",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "Bend Range Fine Up",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "BEND_RANGE_FINE_DW": {
      "id": "BEND_RANGE_FINE_DW",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "Bend Range Fine Down",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "RND_PIT_VAL": {
      "id": "RND_PIT_VAL",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "Pitch Drift",
      "dataRange": [
        0,
        255
      ],
      "initValue": 0
    },
    "RND_PIT_NUM": {
      "id": "RND_PIT_NUM",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "Pitch Drift Cycle Number",
      "dataRange": [
        0,
        8
      ],
      "initValue": 0,
      "values": {
        "0": "FREE",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8"
      }
    },
    "CONDITION": {
      "id": "CONDITION",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "Condition",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "PADDING2": {
      "id": "PADDING2",
      "byteOffset": 9,
      "byteLength": 11,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMS_PMT"] = {
  "name": "PCMS_PMT",
  "description": "PCMSynth PMT",
  "byteLength": 36,
  "parameters": {
    "STRUCT12": {
      "id": "STRUCT12",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Structure1-2",
      "dataRange": [
        0,
        4
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "SYNC",
        "2": "RING",
        "3": "XMOD",
        "4": "XMOD2"
      }
    },
    "STRUCT34": {
      "id": "STRUCT34",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "Structure3-4",
      "dataRange": [
        0,
        4
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "SYNC",
        "2": "RING",
        "3": "XMOD",
        "4": "XMOD2"
      }
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 2,
      "byteLength": 2,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "RING12_LEVEL": {
      "id": "RING12_LEVEL",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "RING1-2 Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "RING34_LEVEL": {
      "id": "RING34_LEVEL",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "RING3-4 Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "RING_OSC1_LEVEL": {
      "id": "RING_OSC1_LEVEL",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "RING OSC1 Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "RING_OSC2_LEVEL": {
      "id": "RING_OSC2_LEVEL",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "RING OSC2 Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "RING_OSC3_LEVEL": {
      "id": "RING_OSC3_LEVEL",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "RING OSC3 Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "RING_OSC4_LEVEL": {
      "id": "RING_OSC4_LEVEL",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "RING OSC4 Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "PADDING2": {
      "id": "PADDING2",
      "byteOffset": 10,
      "byteLength": 2,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "XMOD12_DEPTH": {
      "id": "XMOD12_DEPTH",
      "byteOffset": 12,
      "byteLength": 2,
      "description": "CrossMod1-2 Depth",
      "dataRange": [
        0,
        10800
      ],
      "initValue": 1200,
      "displayMeasurement": "cent"
    },
    "XMOD34_DEPTH": {
      "id": "XMOD34_DEPTH",
      "byteOffset": 14,
      "byteLength": 2,
      "description": "CrossMod3-4 Depth",
      "dataRange": [
        0,
        10800
      ],
      "initValue": 1200,
      "displayMeasurement": "cent"
    },
    "XMOD_OSC1_LEVEL": {
      "id": "XMOD_OSC1_LEVEL",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "CrossMod OSC1 Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "XMOD_OSC2_LEVEL": {
      "id": "XMOD_OSC2_LEVEL",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "CrossMod OSC2 Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "XMOD_OSC3_LEVEL": {
      "id": "XMOD_OSC3_LEVEL",
      "byteOffset": 18,
      "byteLength": 1,
      "description": "CrossMod OSC3 Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "XMOD_OSC4_LEVEL": {
      "id": "XMOD_OSC4_LEVEL",
      "byteOffset": 19,
      "byteLength": 1,
      "description": "CrossMod OSC4 Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "PTL_PHS_LOCK": {
      "id": "PTL_PHS_LOCK",
      "byteOffset": 20,
      "byteLength": 1,
      "description": "Partial Phase Lock",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "XMOD2_12_DEPTH": {
      "id": "XMOD2_12_DEPTH",
      "byteOffset": 21,
      "byteLength": 1,
      "description": "CrossMod2 1-2 Depth",
      "dataRange": [
        0,
        127
      ],
      "initValue": 100
    },
    "XMOD2_34_DEPTH": {
      "id": "XMOD2_34_DEPTH",
      "byteOffset": 22,
      "byteLength": 1,
      "description": "CrossMod2 3-4 Depth",
      "dataRange": [
        0,
        127
      ],
      "initValue": 100
    },
    "PADDING3": {
      "id": "PADDING3",
      "byteOffset": 23,
      "byteLength": 13,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMS_PTL"] = {
  "name": "PCMS_PTL",
  "description": "PCMSynth Partial",
  "byteLength": 36,
  "parameters": {
    "OSC_TYPE": {
      "id": "OSC_TYPE",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "OSC Type",
      "dataRange": [
        0,
        4
      ],
      "initValue": 0,
      "values": {
        "0": "PCM",
        "1": "VA",
        "2": "PCM-Sync",
        "3": "SuperSAW",
        "4": "Noise"
      }
    },
    "VA_FORM": {
      "id": "VA_FORM",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "VA Waveform",
      "dataRange": [
        0,
        8
      ],
      "initValue": 0,
      "values": {
        "0": "SAW",
        "1": "SQR",
        "2": "TRI",
        "3": "SIN",
        "4": "RAMP",
        "5": "JUNO",
        "6": "TRI2",
        "7": "TRI3",
        "8": "SIN2"
      }
    },
    "SYNC_WAV_NUM": {
      "id": "SYNC_WAV_NUM",
      "byteOffset": 2,
      "byteLength": 2,
      "description": "PCM-Sync Wave Number",
      "dataRange": [
        0,
        16383
      ],
      "initValue": 0
    },
    "PW": {
      "id": "PW",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "Pulse Width",
      "dataRange": [
        0,
        127
      ],
      "initValue": 64
    },
    "PWM_DEPTH": {
      "id": "PWM_DEPTH",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "PWM Depth",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "SSAW_DETUNE": {
      "id": "SSAW_DETUNE",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "SuperSAW Detune",
      "dataRange": [
        0,
        127
      ],
      "initValue": 64
    },
    "CLICK_TYPE": {
      "id": "CLICK_TYPE",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "Click Type",
      "dataRange": [
        0,
        3
      ],
      "initValue": 2,
      "values": {
        "0": "SOFT",
        "1": "HARD",
        "2": "NATURAL",
        "3": "OFF"
      }
    },
    "HPF_CUTOFF": {
      "id": "HPF_CUTOFF",
      "byteOffset": 8,
      "byteLength": 2,
      "description": "HPF Cutoff",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "FILTER_TYPE": {
      "id": "FILTER_TYPE",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "Filter Type",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "TVF",
        "1": "VCF"
      }
    },
    "FILTER_SLOPE": {
      "id": "FILTER_SLOPE",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "Filter Slope",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "displayMeasurement": "dB/Oct",
      "values": {
        "0": "-12",
        "1": "-18",
        "2": "-24"
      }
    },
    "ADSR_ENV_SW": {
      "id": "ADSR_ENV_SW",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "ADSREnv Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "FAT": {
      "id": "FAT",
      "byteOffset": 13,
      "byteLength": 1,
      "description": "Fat",
      "dataRange": [
        0,
        127
      ],
      "initValue": 64
    },
    "VCF_TYPE": {
      "id": "VCF_TYPE",
      "byteOffset": 14,
      "byteLength": 1,
      "description": "VCF Type",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "VCF1",
        "1": "JP",
        "2": "MG",
        "3": "P5"
      }
    },
    "OSC_ATT": {
      "id": "OSC_ATT",
      "byteOffset": 15,
      "byteLength": 1,
      "description": "OSC Attenuator",
      "dataRange": [
        0,
        255
      ],
      "initValue": 255
    },
    "CUTOFF_KF_BP": {
      "id": "CUTOFF_KF_BP",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "Cutoff Keyfollow Base Point",
      "dataRange": [
        0,
        127
      ],
      "initValue": 60
    },
    "VA_INVERT_SW": {
      "id": "VA_INVERT_SW",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "VA Waveform Invert Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "FENV_FINE_DEPTH": {
      "id": "FENV_FINE_DEPTH",
      "byteOffset": 18,
      "byteLength": 1,
      "description": "TVF Env Fine Depth",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "PENV_LFO_TRIG_SW": {
      "id": "PENV_LFO_TRIG_SW",
      "byteOffset": 19,
      "byteLength": 1,
      "description": "PENV LFO Trigger Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "FENV_LFO_TRIG_SW": {
      "id": "FENV_LFO_TRIG_SW",
      "byteOffset": 20,
      "byteLength": 1,
      "description": "FENV LFO Trigger Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "AENV_LFO_TRIG_SW": {
      "id": "AENV_LFO_TRIG_SW",
      "byteOffset": 21,
      "byteLength": 1,
      "description": "AENV LFO Trigger Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PITCH_DOWN_DEPTH": {
      "id": "PITCH_DOWN_DEPTH",
      "byteOffset": 22,
      "byteLength": 1,
      "description": "Pitch Down Depth",
      "dataRange": [
        0,
        120
      ],
      "initValue": 0
    },
    "VCF_GC": {
      "id": "VCF_GC",
      "byteOffset": 23,
      "byteLength": 1,
      "description": "VCF Gain Correction",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "VA_INIT_PHASE": {
      "id": "VA_INIT_PHASE",
      "byteOffset": 24,
      "byteLength": 1,
      "description": "VA Init Phase",
      "dataRange": [
        0,
        72
      ],
      "initValue": 0,
      "displayRange": [
        0,
        360
      ]
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 25,
      "byteLength": 11,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMT_CMN"] = {
  "name": "PCMT_CMN",
  "description": "PCMTone Common",
  "byteLength": 64,
  "parameters": {
    "NAME_1": {
      "id": "NAME_1",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Name 1",
      "dataRange": [
        32,
        127
      ],
      "initValue": 32,
      "displayMeasurement": "ASCII"
    },
    "CATEGORY": {
      "id": "CATEGORY",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "Category",
      "dataRange": [
        0,
        50
      ],
      "initValue": 0,
      "values": {
        "0": "None",
        "1": "Ac.Piano",
        "2": "Pop-Piano",
        "3": "E.Grand Piano",
        "4": "E.Piano1",
        "5": "E.Piano2",
        "6": "E.Organ",
        "7": "Pipe Organ",
        "8": "Reed Organ",
        "9": "Harpsichord",
        "10": "Clav",
        "11": "Celesta",
        "12": "Accordion",
        "13": "Harmonica",
        "14": "Bell",
        "15": "Mallet",
        "16": "Ac.Guitar",
        "17": "E.Guitar",
        "18": "Dist.Guitar",
        "19": "Ac.Bass",
        "20": "E.Bass",
        "21": "Synth Bass",
        "22": "Plucked/Stroke",
        "23": "Solo Strings",
        "24": "Ensemble Strs",
        "25": "Orchestral",
        "26": "Solo Brass",
        "27": "Ensemble Brass",
        "28": "Wind",
        "29": "Flute",
        "30": "Sax",
        "31": "Recorder",
        "32": "Vox/Choir",
        "33": "Scat",
        "34": "Synth Lead",
        "35": "Synth Brass",
        "36": "Synth Pad/Str",
        "37": "Synth BellPad",
        "38": "Synth PolyKey",
        "39": "Synth FX",
        "40": "Synth Seq/Pop",
        "41": "Phrase",
        "42": "Pulsating",
        "43": "Beat&Groove",
        "44": "Hit",
        "45": "Sound FX",
        "46": "Drums",
        "47": "Percussion",
        "48": "Stack",
        "49": "Zone",
        "50": "Vocoder"
      }
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "PHRASE": {
      "id": "PHRASE",
      "byteOffset": 18,
      "byteLength": 2,
      "description": "Reserved",
      "dataRange": [
        0,
        0
      ],
      "initValue": 0
    },
    "LEVEL": {
      "id": "LEVEL",
      "byteOffset": 20,
      "byteLength": 1,
      "description": "Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "PAN": {
      "id": "PAN",
      "byteOffset": 21,
      "byteLength": 1,
      "description": "Pan",
      "dataRange": [
        -64,
        63
      ],
      "initValue": 0
    },
    "PADDING2": {
      "id": "PADDING2",
      "byteOffset": 22,
      "byteLength": 2,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "PRIORITY": {
      "id": "PRIORITY",
      "byteOffset": 24,
      "byteLength": 1,
      "description": "Priority",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "LAST",
        "1": "LOUDEST"
      }
    },
    "PIT_CRS": {
      "id": "PIT_CRS",
      "byteOffset": 25,
      "byteLength": 1,
      "description": "Tone Coarse Tune",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0,
      "displayMeasurement": "semitone"
    },
    "PIT_FINE": {
      "id": "PIT_FINE",
      "byteOffset": 26,
      "byteLength": 1,
      "description": "Tone Fine Tune",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0,
      "displayMeasurement": "cent"
    },
    "OCTAVE": {
      "id": "OCTAVE",
      "byteOffset": 27,
      "byteLength": 1,
      "description": "Octave Shift",
      "dataRange": [
        -3,
        3
      ],
      "initValue": 0
    },
    "STRETCH": {
      "id": "STRETCH",
      "byteOffset": 28,
      "byteLength": 1,
      "description": "Stretch Tune Depth",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "1",
        "2": "2",
        "3": "3"
      }
    },
    "ANALOG_FEEL": {
      "id": "ANALOG_FEEL",
      "byteOffset": 29,
      "byteLength": 1,
      "description": "Analog Feel",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "MONO_POLY": {
      "id": "MONO_POLY",
      "byteOffset": 30,
      "byteLength": 1,
      "description": "Mono/Poly",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "MONO",
        "1": "POLY"
      }
    },
    "LEGATO_SW": {
      "id": "LEGATO_SW",
      "byteOffset": 31,
      "byteLength": 1,
      "description": "Legato Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "RETRIG_INTVL": {
      "id": "RETRIG_INTVL",
      "byteOffset": 32,
      "byteLength": 1,
      "description": "Legato Retrigger Interval",
      "dataRange": [
        0,
        13
      ],
      "initValue": 12,
      "values": {
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        "11": "11",
        "12": "12",
        "13": "OFF"
      }
    },
    "PORTA_SW": {
      "id": "PORTA_SW",
      "byteOffset": 33,
      "byteLength": 1,
      "description": "Portamento Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PORTA_MODE": {
      "id": "PORTA_MODE",
      "byteOffset": 34,
      "byteLength": 1,
      "description": "Portamento Mode",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "NORMAL",
        "1": "LEGATO"
      }
    },
    "PORTA_TYPE": {
      "id": "PORTA_TYPE",
      "byteOffset": 35,
      "byteLength": 1,
      "description": "Portamento Type",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "RATE",
        "1": "TIME"
      }
    },
    "PADDING3": {
      "id": "PADDING3",
      "byteOffset": 36,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "PORTA_START": {
      "id": "PORTA_START",
      "byteOffset": 37,
      "byteLength": 1,
      "description": "Portamento Start",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "PITCH",
        "1": "NOTE"
      }
    },
    "PORTA_TIME": {
      "id": "PORTA_TIME",
      "byteOffset": 38,
      "byteLength": 2,
      "description": "Portamento Time",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 73
    },
    "BEND_RANGE_UP": {
      "id": "BEND_RANGE_UP",
      "byteOffset": 40,
      "byteLength": 1,
      "description": "Bend Range Up",
      "dataRange": [
        0,
        48
      ],
      "initValue": 2
    },
    "BEND_RANGE_DW": {
      "id": "BEND_RANGE_DW",
      "byteOffset": 41,
      "byteLength": 1,
      "description": "Bend Range Down",
      "dataRange": [
        0,
        48
      ],
      "initValue": 2
    },
    "BEND_MODE": {
      "id": "BEND_MODE",
      "byteOffset": 42,
      "byteLength": 1,
      "description": "Bend Mode",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "NORMAL",
        "1": "CATCH+LAST"
      }
    },
    "SOFT_LEVEL_SENS": {
      "id": "SOFT_LEVEL_SENS",
      "byteOffset": 43,
      "byteLength": 1,
      "description": "Soft Level Sens",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "PHRASE_OCT": {
      "id": "PHRASE_OCT",
      "byteOffset": 44,
      "byteLength": 1,
      "description": "Reserved",
      "dataRange": [
        0,
        0
      ],
      "initValue": 0
    },
    "PHRASE_VEL_RATE": {
      "id": "PHRASE_VEL_RATE",
      "byteOffset": 45,
      "byteLength": 1,
      "description": "Reserved",
      "dataRange": [
        0,
        0
      ],
      "initValue": 0
    },
    "PHRASE_VEL_SHIFT": {
      "id": "PHRASE_VEL_SHIFT",
      "byteOffset": 46,
      "byteLength": 1,
      "description": "Reserved",
      "dataRange": [
        0,
        0
      ],
      "initValue": 0
    },
    "SYMP_DEPTH": {
      "id": "SYMP_DEPTH",
      "byteOffset": 47,
      "byteLength": 1,
      "description": "Reserved",
      "dataRange": [
        0,
        0
      ],
      "initValue": 0
    },
    "PORTA_CRV": {
      "id": "PORTA_CRV",
      "byteOffset": 48,
      "byteLength": 1,
      "description": "Portamento Curve Type",
      "dataRange": [
        0,
        2
      ],
      "initValue": 0,
      "displayRange": [
        1,
        3
      ]
    },
    "PTL_LFO_LOCK": {
      "id": "PTL_LFO_LOCK",
      "byteOffset": 49,
      "byteLength": 1,
      "description": "Partial LFO Phase Lock",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PADDING4": {
      "id": "PADDING4",
      "byteOffset": 50,
      "byteLength": 14,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMT_PMT_PMT"] = {
  "name": "PCMT_PMT_PMT",
  "description": "PMT",
  "byteLength": 12,
  "parameters": {
    "PTL_SW": {
      "id": "PTL_SW",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Partial Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 1,
      "byteLength": 3,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "KRANGE_LO": {
      "id": "KRANGE_LO",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "KeyRange Lower",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "KRANGE_UP": {
      "id": "KRANGE_UP",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "KeyRange Upper",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "KFADE_LO": {
      "id": "KFADE_LO",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "KeyFade Lower",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "KFADE_UP": {
      "id": "KFADE_UP",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "KeyFade Upper",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "VRANGE_LO": {
      "id": "VRANGE_LO",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "VeloRange Lower",
      "dataRange": [
        1,
        127
      ],
      "initValue": 1
    },
    "VRANGE_UP": {
      "id": "VRANGE_UP",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "VeloRange Upper",
      "dataRange": [
        1,
        127
      ],
      "initValue": 127
    },
    "VFADE_LO": {
      "id": "VFADE_LO",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "VeloFade Lower",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "VFADE_UP": {
      "id": "VFADE_UP",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "VeloFade Upper",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMT_PMT"] = {
  "name": "PCMT_PMT",
  "description": "PCMTone PartialMixTable",
  "byteLength": 52,
  "parameters": {
    "VEL_CTRL": {
      "id": "VEL_CTRL",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Velocity Control",
      "dataRange": [
        0,
        3
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "ON",
        "2": "RANDOM",
        "3": "CYCLE"
      }
    },
    "PMT_LEVEL_CRV": {
      "id": "PMT_LEVEL_CRV",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "PMT Level Curve",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "EXP",
        "1": "LINEAR"
      }
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 2,
      "byteLength": 2,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "PMT": {
      "id": "PMT",
      "byteOffset": 4,
      "byteLength": 48,
      "description": "PMT",
      "blockName": "PCMT_PMT_PMT",
      "count": 4,
      "blockByteLength": 12,
      "block": ZenProperties["PCMT_PMT_PMT"]
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMT_PTL_MCTL"] = {
  "name": "PCMT_PTL_MCTL",
  "description": "Matrix Control",
  "byteLength": 12,
  "parameters": {
    "SRC": {
      "id": "SRC",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Source",
      "dataRange": [
        0,
        108
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "CC01",
        "2": "CC02",
        "3": "CC03",
        "4": "CC04",
        "5": "CC05",
        "6": "CC06",
        "7": "CC07",
        "8": "CC08",
        "9": "CC09",
        "10": "CC10",
        "11": "CC11",
        "12": "CC12",
        "13": "CC13",
        "14": "CC14",
        "15": "CC15",
        "16": "CC16",
        "17": "CC17",
        "18": "CC18",
        "19": "CC19",
        "20": "CC20",
        "21": "CC21",
        "22": "CC22",
        "23": "CC23",
        "24": "CC24",
        "25": "CC25",
        "26": "CC26",
        "27": "CC27",
        "28": "CC28",
        "29": "CC29",
        "30": "CC30",
        "31": "CC31",
        "32": "CC33",
        "33": "CC34",
        "34": "CC35",
        "35": "CC36",
        "36": "CC37",
        "37": "CC38",
        "38": "CC39",
        "39": "CC40",
        "40": "CC41",
        "41": "CC42",
        "42": "CC43",
        "43": "CC44",
        "44": "CC45",
        "45": "CC46",
        "46": "CC47",
        "47": "CC48",
        "48": "CC49",
        "49": "CC50",
        "50": "CC51",
        "51": "CC52",
        "52": "CC53",
        "53": "CC54",
        "54": "CC55",
        "55": "CC56",
        "56": "CC57",
        "57": "CC58",
        "58": "CC59",
        "59": "CC60",
        "60": "CC61",
        "61": "CC62",
        "62": "CC63",
        "63": "CC64",
        "64": "CC65",
        "65": "CC66",
        "66": "CC67",
        "67": "CC68",
        "68": "CC69",
        "69": "CC70",
        "70": "CC71",
        "71": "CC72",
        "72": "CC73",
        "73": "CC74",
        "74": "CC75",
        "75": "CC76",
        "76": "CC77",
        "77": "CC78",
        "78": "CC79",
        "79": "CC80",
        "80": "CC81",
        "81": "CC82",
        "82": "CC83",
        "83": "CC84",
        "84": "CC85",
        "85": "CC86",
        "86": "CC87",
        "87": "CC88",
        "88": "CC89",
        "89": "CC90",
        "90": "CC91",
        "91": "CC92",
        "92": "CC93",
        "93": "CC94",
        "94": "CC95",
        "95": "BEND",
        "96": "AFT",
        "97": "SYS-CTRL1",
        "98": "SYS-CTRL2",
        "99": "SYS-CTRL3",
        "100": "SYS-CTRL4",
        "101": "VELOCITY",
        "102": "KEYFOLLOW",
        "103": "TEMPO",
        "104": "LFO1",
        "105": "LFO2",
        "106": "PIT-ENV",
        "107": "TVF-ENV",
        "108": "TVA-ENV"
      }
    },
    "DST1": {
      "id": "DST1",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "Destination 1",
      "dataRange": [
        0,
        48
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "PCH",
        "2": "CUT",
        "3": "RES",
        "4": "LEV",
        "5": "PAN",
        "6": "CHO",
        "7": "REV",
        "8": "PIT-LFO1",
        "9": "PIT-LFO2",
        "10": "TVF-LFO1",
        "11": "TVF-LFO2",
        "12": "TVA-LFO1",
        "13": "TVA-LFO2",
        "14": "PAN-LFO1",
        "15": "PAN-LFO2",
        "16": "LFO1-RATE",
        "17": "LFO2-RATE",
        "18": "PIT-ATK",
        "19": "PIT-DCY",
        "20": "PIT-REL",
        "21": "TVF-ATK",
        "22": "TVF-DCY",
        "23": "TVF-REL",
        "24": "TVA-ATK",
        "25": "TVA-DCY",
        "26": "TVA-REL",
        "27": "PMT",
        "28": "FXM",
        "29": "MFX-CTRL1",
        "30": "MFX-CTRL2",
        "31": "MFX-CTRL3",
        "32": "MFX-CTRL4",
        "33": "PW",
        "34": "PWM",
        "35": "FAT",
        "36": "XMOD",
        "37": "LFO1_STEP",
        "38": "LFO2_STEP",
        "39": "SSAW-DETN",
        "40": "PIT_DEPTH",
        "41": "TVF-DEPTH",
        "42": "TVA-DEPTH",
        "43": "XMOD2",
        "44": "ATT",
        "45": "RING-OSC1-LEV",
        "46": "RING-OSC2-LEV",
        "47": "XMOD-OSC1-LEV",
        "48": "XMOD-OSC2-LEV"
      }
    },
    "SENS1": {
      "id": "SENS1",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "Sens 1",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "DST2": {
      "id": "DST2",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "Destination 2",
      "dataRange": [
        0,
        48
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "PCH",
        "2": "CUT",
        "3": "RES",
        "4": "LEV",
        "5": "PAN",
        "6": "CHO",
        "7": "REV",
        "8": "PIT-LFO1",
        "9": "PIT-LFO2",
        "10": "TVF-LFO1",
        "11": "TVF-LFO2",
        "12": "TVA-LFO1",
        "13": "TVA-LFO2",
        "14": "PAN-LFO1",
        "15": "PAN-LFO2",
        "16": "LFO1-RATE",
        "17": "LFO2-RATE",
        "18": "PIT-ATK",
        "19": "PIT-DCY",
        "20": "PIT-REL",
        "21": "TVF-ATK",
        "22": "TVF-DCY",
        "23": "TVF-REL",
        "24": "TVA-ATK",
        "25": "TVA-DCY",
        "26": "TVA-REL",
        "27": "PMT",
        "28": "FXM",
        "29": "MFX-CTRL1",
        "30": "MFX-CTRL2",
        "31": "MFX-CTRL3",
        "32": "MFX-CTRL4",
        "33": "PW",
        "34": "PWM",
        "35": "FAT",
        "36": "XMOD",
        "37": "LFO1_STEP",
        "38": "LFO2_STEP",
        "39": "SSAW-DETN",
        "40": "PIT_DEPTH",
        "41": "TVF-DEPTH",
        "42": "TVA-DEPTH",
        "43": "XMOD2",
        "44": "ATT",
        "45": "RING-OSC1-LEV",
        "46": "RING-OSC2-LEV",
        "47": "XMOD-OSC1-LEV",
        "48": "XMOD-OSC2-LEV"
      }
    },
    "SENS2": {
      "id": "SENS2",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "Sens 2",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "DST3": {
      "id": "DST3",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "Destination 3",
      "dataRange": [
        0,
        48
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "PCH",
        "2": "CUT",
        "3": "RES",
        "4": "LEV",
        "5": "PAN",
        "6": "CHO",
        "7": "REV",
        "8": "PIT-LFO1",
        "9": "PIT-LFO2",
        "10": "TVF-LFO1",
        "11": "TVF-LFO2",
        "12": "TVA-LFO1",
        "13": "TVA-LFO2",
        "14": "PAN-LFO1",
        "15": "PAN-LFO2",
        "16": "LFO1-RATE",
        "17": "LFO2-RATE",
        "18": "PIT-ATK",
        "19": "PIT-DCY",
        "20": "PIT-REL",
        "21": "TVF-ATK",
        "22": "TVF-DCY",
        "23": "TVF-REL",
        "24": "TVA-ATK",
        "25": "TVA-DCY",
        "26": "TVA-REL",
        "27": "PMT",
        "28": "FXM",
        "29": "MFX-CTRL1",
        "30": "MFX-CTRL2",
        "31": "MFX-CTRL3",
        "32": "MFX-CTRL4",
        "33": "PW",
        "34": "PWM",
        "35": "FAT",
        "36": "XMOD",
        "37": "LFO1_STEP",
        "38": "LFO2_STEP",
        "39": "SSAW-DETN",
        "40": "PIT_DEPTH",
        "41": "TVF-DEPTH",
        "42": "TVA-DEPTH",
        "43": "XMOD2",
        "44": "ATT",
        "45": "RING-OSC1-LEV",
        "46": "RING-OSC2-LEV",
        "47": "XMOD-OSC1-LEV",
        "48": "XMOD-OSC2-LEV"
      }
    },
    "SENS3": {
      "id": "SENS3",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "Sens 3",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "DST4": {
      "id": "DST4",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "Destination 4",
      "dataRange": [
        0,
        48
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "PCH",
        "2": "CUT",
        "3": "RES",
        "4": "LEV",
        "5": "PAN",
        "6": "CHO",
        "7": "REV",
        "8": "PIT-LFO1",
        "9": "PIT-LFO2",
        "10": "TVF-LFO1",
        "11": "TVF-LFO2",
        "12": "TVA-LFO1",
        "13": "TVA-LFO2",
        "14": "PAN-LFO1",
        "15": "PAN-LFO2",
        "16": "LFO1-RATE",
        "17": "LFO2-RATE",
        "18": "PIT-ATK",
        "19": "PIT-DCY",
        "20": "PIT-REL",
        "21": "TVF-ATK",
        "22": "TVF-DCY",
        "23": "TVF-REL",
        "24": "TVA-ATK",
        "25": "TVA-DCY",
        "26": "TVA-REL",
        "27": "PMT",
        "28": "FXM",
        "29": "MFX-CTRL1",
        "30": "MFX-CTRL2",
        "31": "MFX-CTRL3",
        "32": "MFX-CTRL4",
        "33": "PW",
        "34": "PWM",
        "35": "FAT",
        "36": "XMOD",
        "37": "LFO1_STEP",
        "38": "LFO2_STEP",
        "39": "SSAW-DETN",
        "40": "PIT_DEPTH",
        "41": "TVF-DEPTH",
        "42": "TVA-DEPTH",
        "43": "XMOD2",
        "44": "ATT",
        "45": "RING-OSC1-LEV",
        "46": "RING-OSC2-LEV",
        "47": "XMOD-OSC1-LEV",
        "48": "XMOD-OSC2-LEV"
      }
    },
    "SENS4": {
      "id": "SENS4",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "Sens 4",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 9,
      "byteLength": 3,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMT_PTL"] = {
  "name": "PCMT_PTL",
  "description": "PCMTone Partial",
  "byteLength": 124,
  "parameters": {
    "LEVEL": {
      "id": "LEVEL",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 127
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "PIT_CRS": {
      "id": "PIT_CRS",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "Coarse Tune",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0
    },
    "PIT_FINE": {
      "id": "PIT_FINE",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "Fine Tune",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0,
      "displayMeasurement": "cent"
    },
    "PIT_RND": {
      "id": "PIT_RND",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "Random Pitch Depth",
      "dataRange": [
        0,
        1200
      ],
      "initValue": 0,
      "displayMeasurement": "cent"
    },
    "PAN": {
      "id": "PAN",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "Pan",
      "dataRange": [
        -64,
        63
      ],
      "initValue": 0
    },
    "PAN_KF": {
      "id": "PAN_KF",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "Pan Keyfollow",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "PAN_RND": {
      "id": "PAN_RND",
      "byteOffset": 8,
      "byteLength": 1,
      "description": "Random Pan Depth",
      "dataRange": [
        0,
        63
      ],
      "initValue": 0
    },
    "PAN_ALT": {
      "id": "PAN_ALT",
      "byteOffset": 9,
      "byteLength": 1,
      "description": "Alternate Pan Depth",
      "dataRange": [
        -64,
        63
      ],
      "initValue": 0
    },
    "ENV_MODE": {
      "id": "ENV_MODE",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "Envelope Mode",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "NO-SUS",
        "1": "SUSTAIN"
      }
    },
    "DELAY_MODE": {
      "id": "DELAY_MODE",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "Delay Mode",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "NORMAL",
        "1": "HOLD",
        "2": "KEYOFF-NORMAL",
        "3": "KEYOFF-DECAY"
      }
    },
    "DLY_TIME_SYNC": {
      "id": "DLY_TIME_SYNC",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "DelayTime Sync",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "DLY_TIME_NOTE": {
      "id": "DLY_TIME_NOTE",
      "byteOffset": 13,
      "byteLength": 1,
      "description": "DelayTime (note)",
      "dataRange": [
        0,
        21
      ],
      "initValue": 12,
      "values": {
        "0": "1/64T",
        "1": "1/64",
        "2": "1/32T",
        "3": "1/32",
        "4": "1/16T",
        "5": "1/32.",
        "6": "1/16",
        "7": "1/8T",
        "8": "1/16.",
        "9": "1/8",
        "10": "1/4T",
        "11": "1/8.",
        "12": "1/4",
        "13": "1/2T",
        "14": "1/4.",
        "15": "1/2",
        "16": "1T",
        "17": "1/2.",
        "18": "1",
        "19": "2T",
        "20": "1.",
        "21": "2"
      }
    },
    "DLY_TIME": {
      "id": "DLY_TIME",
      "byteOffset": 14,
      "byteLength": 2,
      "description": "DelayTime",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "CHO_SEND": {
      "id": "CHO_SEND",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "Chorus Send Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "REV_SEND": {
      "id": "REV_SEND",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "Reverb Send Level",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "RX_BEND": {
      "id": "RX_BEND",
      "byteOffset": 18,
      "byteLength": 1,
      "description": "Receive Bender",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "RX_EXPR": {
      "id": "RX_EXPR",
      "byteOffset": 19,
      "byteLength": 1,
      "description": "Receive Expression",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "RX_HOLD": {
      "id": "RX_HOLD",
      "byteOffset": 20,
      "byteLength": 1,
      "description": "Receive Hold-1",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "REDAMP_SW": {
      "id": "REDAMP_SW",
      "byteOffset": 21,
      "byteLength": 1,
      "description": "Redamper Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "OUT_ASGN": {
      "id": "OUT_ASGN",
      "byteOffset": 22,
      "byteLength": 1,
      "description": "Output Assign",
      "dataRange": [
        0,
        1
      ],
      "initValue": 1,
      "values": {
        "0": "DRY",
        "1": "MFX"
      }
    },
    "WAV_GTYPE": {
      "id": "WAV_GTYPE",
      "byteOffset": 23,
      "byteLength": 1,
      "description": "Wave Group Type",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "INT",
        "1": "EXP",
        "2": "SAMP",
        "3": "MSAMP"
      }
    },
    "WAV_GID": {
      "id": "WAV_GID",
      "byteOffset": 24,
      "byteLength": 2,
      "description": "Wave Group ID",
      "dataRange": [
        0,
        16383
      ],
      "initValue": 0
    },
    "WAV_NUM_L": {
      "id": "WAV_NUM_L",
      "byteOffset": 26,
      "byteLength": 2,
      "description": "Wave Number L",
      "dataRange": [
        0,
        16383
      ],
      "initValue": 0
    },
    "WAV_NUM_R": {
      "id": "WAV_NUM_R",
      "byteOffset": 28,
      "byteLength": 2,
      "description": "Wave Number R",
      "dataRange": [
        0,
        16383
      ],
      "initValue": 0
    },
    "WAV_GAIN": {
      "id": "WAV_GAIN",
      "byteOffset": 30,
      "byteLength": 1,
      "description": "Gain",
      "dataRange": [
        0,
        5
      ],
      "initValue": 3,
      "displayMeasurement": "dB",
      "values": {
        "0": "-18",
        "1": "-12",
        "2": "-6",
        "3": "0",
        "4": "+6",
        "5": "+12"
      }
    },
    "FXM_SW": {
      "id": "FXM_SW",
      "byteOffset": 31,
      "byteLength": 1,
      "description": "FXM Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "FXM_COLOR": {
      "id": "FXM_COLOR",
      "byteOffset": 32,
      "byteLength": 1,
      "description": "FXM Color",
      "dataRange": [
        1,
        4
      ],
      "initValue": 1
    },
    "FXM_DEPTH": {
      "id": "FXM_DEPTH",
      "byteOffset": 33,
      "byteLength": 1,
      "description": "FXM Depth",
      "dataRange": [
        0,
        16
      ],
      "initValue": 0
    },
    "PIT_KF": {
      "id": "PIT_KF",
      "byteOffset": 34,
      "byteLength": 2,
      "description": "Pitch Keyfollow",
      "dataRange": [
        -200,
        200
      ],
      "initValue": 100
    },
    "SOFT_EQ_SENS": {
      "id": "SOFT_EQ_SENS",
      "byteOffset": 36,
      "byteLength": 1,
      "description": "Soft EQ Sens",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0
    },
    "FILTER_TYPE": {
      "id": "FILTER_TYPE",
      "byteOffset": 37,
      "byteLength": 1,
      "description": "TVF Filter Type",
      "dataRange": [
        0,
        6
      ],
      "initValue": 1,
      "values": {
        "0": "OFF",
        "1": "LPF",
        "2": "BPF",
        "3": "HPF",
        "4": "PKG",
        "5": "LPF2",
        "6": "LPF3"
      }
    },
    "PADDING2": {
      "id": "PADDING2",
      "byteOffset": 38,
      "byteLength": 2,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "CUTOFF": {
      "id": "CUTOFF",
      "byteOffset": 40,
      "byteLength": 2,
      "description": "TVF Cutoff Frequency",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    },
    "CUTOFF_KF": {
      "id": "CUTOFF_KF",
      "byteOffset": 42,
      "byteLength": 2,
      "description": "TVF Cutoff Keyfollow",
      "dataRange": [
        -200,
        200
      ],
      "initValue": 0
    },
    "CUTOFF_VCRV": {
      "id": "CUTOFF_VCRV",
      "byteOffset": 44,
      "byteLength": 1,
      "description": "TVF Cutoff Velocity Curve",
      "dataRange": [
        0,
        7
      ],
      "initValue": 1,
      "values": {
        "0": "FIXED",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7"
      }
    },
    "CUTOFF_VSENS": {
      "id": "CUTOFF_VSENS",
      "byteOffset": 45,
      "byteLength": 1,
      "description": "TVF Cutoff Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "RESO": {
      "id": "RESO",
      "byteOffset": 46,
      "byteLength": 2,
      "description": "TVF Resonance",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "RESO_VSENS": {
      "id": "RESO_VSENS",
      "byteOffset": 48,
      "byteLength": 1,
      "description": "TVF Resonance Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "BIAS_LEVEL": {
      "id": "BIAS_LEVEL",
      "byteOffset": 49,
      "byteLength": 1,
      "description": "Bias Level",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "BIAS_POS": {
      "id": "BIAS_POS",
      "byteOffset": 50,
      "byteLength": 1,
      "description": "Bias Position",
      "dataRange": [
        0,
        127
      ],
      "initValue": 60
    },
    "BIAS_DIR": {
      "id": "BIAS_DIR",
      "byteOffset": 51,
      "byteLength": 1,
      "description": "Bias Direction",
      "dataRange": [
        0,
        3
      ],
      "initValue": 3,
      "values": {
        "0": "LOWER",
        "1": "UPPER",
        "2": "LOWER&UPPER",
        "3": "ALL"
      }
    },
    "LEVEL_VCRV": {
      "id": "LEVEL_VCRV",
      "byteOffset": 52,
      "byteLength": 1,
      "description": "TVA Level Velocity Curve",
      "dataRange": [
        0,
        7
      ],
      "initValue": 1,
      "values": {
        "0": "FIXED",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7"
      }
    },
    "LEVEL_VSENS": {
      "id": "LEVEL_VSENS",
      "byteOffset": 53,
      "byteLength": 1,
      "description": "TVA Level Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "PENV_TKF": {
      "id": "PENV_TKF",
      "byteOffset": 54,
      "byteLength": 1,
      "description": "Pitch Env Time Keyfollow",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "FENV_TKF": {
      "id": "FENV_TKF",
      "byteOffset": 55,
      "byteLength": 1,
      "description": "TVF Env Time Keyfollow",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "AENV_TKF": {
      "id": "AENV_TKF",
      "byteOffset": 56,
      "byteLength": 1,
      "description": "TVA Env Time Keyfollow",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "VIB_PIT_SENS": {
      "id": "VIB_PIT_SENS",
      "byteOffset": 57,
      "byteLength": 1,
      "description": "Vibrato Pitch Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 10
    },
    "VIB_CUT_SENS": {
      "id": "VIB_CUT_SENS",
      "byteOffset": 58,
      "byteLength": 1,
      "description": "Vibrato Cutoff Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "VIB_AMP_SENS": {
      "id": "VIB_AMP_SENS",
      "byteOffset": 59,
      "byteLength": 1,
      "description": "Vibrato Level Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "MCTL": {
      "id": "MCTL",
      "byteOffset": 60,
      "byteLength": 48,
      "description": "Matrix Control",
      "blockName": "PCMT_PTL_MCTL",
      "count": 4,
      "blockByteLength": 12,
      "block": ZenProperties["PCMT_PTL_MCTL"]
    },
    "DAMP_FREE": {
      "id": "DAMP_FREE",
      "byteOffset": 108,
      "byteLength": 1,
      "description": "Damper Free Note",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        "11": "11",
        "12": "12",
        "13": "13",
        "14": "14",
        "15": "15",
        "16": "16",
        "17": "17",
        "18": "18",
        "19": "19",
        "20": "20",
        "21": "21",
        "22": "22",
        "23": "23",
        "24": "24",
        "25": "25",
        "26": "26",
        "27": "27",
        "28": "28",
        "29": "29",
        "30": "30",
        "31": "31",
        "32": "32",
        "33": "33",
        "34": "34",
        "35": "35",
        "36": "36",
        "37": "37",
        "38": "38",
        "39": "39",
        "40": "40",
        "41": "41",
        "42": "42",
        "43": "43",
        "44": "44",
        "45": "45",
        "46": "46",
        "47": "47",
        "48": "48",
        "49": "49",
        "50": "50",
        "51": "51",
        "52": "52",
        "53": "53",
        "54": "54",
        "55": "55",
        "56": "56",
        "57": "57",
        "58": "58",
        "59": "59",
        "60": "60",
        "61": "61",
        "62": "62",
        "63": "63",
        "64": "64",
        "65": "65",
        "66": "66",
        "67": "67",
        "68": "68",
        "69": "69",
        "70": "70",
        "71": "71",
        "72": "72",
        "73": "73",
        "74": "74",
        "75": "75",
        "76": "76",
        "77": "77",
        "78": "78",
        "79": "79",
        "80": "80",
        "81": "81",
        "82": "82",
        "83": "83",
        "84": "84",
        "85": "85",
        "86": "86",
        "87": "87",
        "88": "88",
        "89": "89",
        "90": "90",
        "91": "91",
        "92": "92",
        "93": "93",
        "94": "94",
        "95": "95",
        "96": "96",
        "97": "97",
        "98": "98",
        "99": "99",
        "100": "100",
        "101": "101",
        "102": "102",
        "103": "103",
        "104": "104",
        "105": "105",
        "106": "106",
        "107": "107",
        "108": "108",
        "109": "109",
        "110": "110",
        "111": "111",
        "112": "112",
        "113": "113",
        "114": "114",
        "115": "115",
        "116": "116",
        "117": "117",
        "118": "118",
        "119": "119",
        "120": "120",
        "121": "121",
        "122": "122",
        "123": "123",
        "124": "124",
        "125": "125",
        "126": "126",
        "127": "127",
        "128": ""
      }
    },
    "STEREO_WIDTH": {
      "id": "STEREO_WIDTH",
      "byteOffset": 109,
      "byteLength": 1,
      "description": "Stereo Width",
      "dataRange": [
        0,
        100
      ],
      "initValue": 100
    },
    "STEREO_DETN": {
      "id": "STEREO_DETN",
      "byteOffset": 110,
      "byteLength": 1,
      "description": "Stereo Detune",
      "dataRange": [
        -50,
        50
      ],
      "initValue": 0,
      "displayMeasurement": "cent"
    },
    "DF_DCY_OFST": {
      "id": "DF_DCY_OFST",
      "byteOffset": 111,
      "byteLength": 1,
      "description": "Damper Free Decay Offset",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "TEMPO_SYNC": {
      "id": "TEMPO_SYNC",
      "byteOffset": 112,
      "byteLength": 1,
      "description": "Wave Tempo Sync",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PADDING3": {
      "id": "PADDING3",
      "byteOffset": 113,
      "byteLength": 11,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PTL_AENV"] = {
  "name": "PTL_AENV",
  "description": "Partial TVA Envelope",
  "byteLength": 16,
  "parameters": {
    "T1_VSENS": {
      "id": "T1_VSENS",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "TVA Env Time1 Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "T4_VSENS": {
      "id": "T4_VSENS",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "TVA Env Time4 Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "T1": {
      "id": "T1",
      "byteOffset": 2,
      "byteLength": 2,
      "description": "TVA Env Time1",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "T2": {
      "id": "T2",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "TVA Env Time2",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 30
    },
    "T3": {
      "id": "T3",
      "byteOffset": 6,
      "byteLength": 2,
      "description": "TVA Env Time3",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 400
    },
    "T4": {
      "id": "T4",
      "byteOffset": 8,
      "byteLength": 2,
      "description": "TVA Env Time4",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 400
    },
    "L1": {
      "id": "L1",
      "byteOffset": 10,
      "byteLength": 2,
      "description": "TVA Env Level1",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    },
    "L2": {
      "id": "L2",
      "byteOffset": 12,
      "byteLength": 2,
      "description": "TVA Env Level2",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    },
    "L3": {
      "id": "L3",
      "byteOffset": 14,
      "byteLength": 2,
      "description": "TVA Env Level3",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PTL_EQ"] = {
  "name": "PTL_EQ",
  "description": "Partial EQ",
  "byteLength": 16,
  "parameters": {
    "LO_GAIN": {
      "id": "LO_GAIN",
      "byteOffset": 0,
      "byteLength": 2,
      "description": "EQ Low Gain",
      "dataRange": [
        -240,
        240
      ],
      "initValue": 0,
      "displayMeasurement": "EQGAIN",
      "displayRange": [
        -24,
        24
      ]
    },
    "MID_GAIN": {
      "id": "MID_GAIN",
      "byteOffset": 2,
      "byteLength": 2,
      "description": "EQ Mid Gain",
      "dataRange": [
        -240,
        240
      ],
      "initValue": 0,
      "displayMeasurement": "EQGAIN",
      "displayRange": [
        -24,
        24
      ]
    },
    "HI_GAIN": {
      "id": "HI_GAIN",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "EQ High Gain",
      "dataRange": [
        -240,
        240
      ],
      "initValue": 0,
      "displayMeasurement": "EQGAIN",
      "displayRange": [
        -24,
        24
      ]
    },
    "LO_FREQ": {
      "id": "LO_FREQ",
      "byteOffset": 6,
      "byteLength": 2,
      "description": "EQ Low Frequency",
      "dataRange": [
        20,
        16000
      ],
      "initValue": 200,
      "displayMeasurement": "EQFREQ"
    },
    "MID_FREQ": {
      "id": "MID_FREQ",
      "byteOffset": 8,
      "byteLength": 2,
      "description": "EQ Mid Frequency",
      "dataRange": [
        20,
        16000
      ],
      "initValue": 1000,
      "displayMeasurement": "EQFREQ"
    },
    "HI_FREQ": {
      "id": "HI_FREQ",
      "byteOffset": 10,
      "byteLength": 2,
      "description": "EQ High Frequency",
      "dataRange": [
        20,
        16000
      ],
      "initValue": 2000,
      "displayMeasurement": "EQFREQ"
    },
    "MID_Q": {
      "id": "MID_Q",
      "byteOffset": 12,
      "byteLength": 1,
      "description": "EQ Mid Q",
      "dataRange": [
        5,
        160
      ],
      "initValue": 10,
      "displayMeasurement": "EQQ",
      "displayRange": [
        0.5,
        16
      ]
    },
    "SW": {
      "id": "SW",
      "byteOffset": 13,
      "byteLength": 1,
      "description": "EQ Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 14,
      "byteLength": 2,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PTL_FENV"] = {
  "name": "PTL_FENV",
  "description": "Partial TVF Envelope",
  "byteLength": 24,
  "parameters": {
    "DEPTH": {
      "id": "DEPTH",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "TVF Env Depth",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "VCRV": {
      "id": "VCRV",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "TVF Env Velocity Curve",
      "dataRange": [
        0,
        7
      ],
      "initValue": 1,
      "values": {
        "0": "FIXED",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7"
      }
    },
    "VSENS": {
      "id": "VSENS",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "TVF Env Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "T1_VSENS": {
      "id": "T1_VSENS",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "TVF Env T1 Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "T4_VSENS": {
      "id": "T4_VSENS",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "TVF Env T4 Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    },
    "T1": {
      "id": "T1",
      "byteOffset": 6,
      "byteLength": 2,
      "description": "TVF Env Time1",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "T2": {
      "id": "T2",
      "byteOffset": 8,
      "byteLength": 2,
      "description": "TVF Env Time2",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "T3": {
      "id": "T3",
      "byteOffset": 10,
      "byteLength": 2,
      "description": "TVF Env Time3",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "T4": {
      "id": "T4",
      "byteOffset": 12,
      "byteLength": 2,
      "description": "TVF Env Time4",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "L0": {
      "id": "L0",
      "byteOffset": 14,
      "byteLength": 2,
      "description": "TVF Env Level0",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "L1": {
      "id": "L1",
      "byteOffset": 16,
      "byteLength": 2,
      "description": "TVF Env Level1",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    },
    "L2": {
      "id": "L2",
      "byteOffset": 18,
      "byteLength": 2,
      "description": "TVF Env Level2",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    },
    "L3": {
      "id": "L3",
      "byteOffset": 20,
      "byteLength": 2,
      "description": "TVF Env Level3",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 1023
    },
    "L4": {
      "id": "L4",
      "byteOffset": 22,
      "byteLength": 2,
      "description": "TVF Env Level4",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PTL_LFO_LFO"] = {
  "name": "PTL_LFO_LFO",
  "description": "LFO",
  "byteLength": 52,
  "parameters": {
    "FORM": {
      "id": "FORM",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Waveform",
      "dataRange": [
        0,
        10
      ],
      "initValue": 1,
      "values": {
        "0": "SIN",
        "1": "TRI",
        "2": "SAW-UP",
        "3": "SAW-DW",
        "4": "SQR",
        "5": "RND",
        "6": "TRP",
        "7": "S&H",
        "8": "CHS",
        "9": "VSIN",
        "10": "STEP"
      }
    },
    "RATE_SYNC": {
      "id": "RATE_SYNC",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "Rate Sync",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "RATE_NOTE": {
      "id": "RATE_NOTE",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "Rate (note)",
      "dataRange": [
        0,
        22
      ],
      "initValue": 12,
      "values": {
        "0": "1/64T",
        "1": "1/64",
        "2": "1/32T",
        "3": "1/32",
        "4": "1/16T",
        "5": "1/32.",
        "6": "1/16",
        "7": "1/8T",
        "8": "1/16.",
        "9": "1/8",
        "10": "1/4T",
        "11": "1/8.",
        "12": "1/4",
        "13": "1/2T",
        "14": "1/4.",
        "15": "1/2",
        "16": "1T",
        "17": "1/2.",
        "18": "1",
        "19": "2T",
        "20": "1.",
        "21": "2",
        "22": "4"
      }
    },
    "STEP_MAX": {
      "id": "STEP_MAX",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "Step Size",
      "dataRange": [
        0,
        15
      ],
      "initValue": 15,
      "displayRange": [
        1,
        16
      ]
    },
    "RATE": {
      "id": "RATE",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "Rate",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 650
    },
    "OFST": {
      "id": "OFST",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "Offset",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "RATE_DETN": {
      "id": "RATE_DETN",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "Rate Detune",
      "dataRange": [
        0,
        127
      ],
      "initValue": 0
    },
    "DELAY": {
      "id": "DELAY",
      "byteOffset": 8,
      "byteLength": 2,
      "description": "Delay Time",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "DELAY_KF": {
      "id": "DELAY_KF",
      "byteOffset": 10,
      "byteLength": 1,
      "description": "Delay Time Keyfolow",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "FADE_MODE": {
      "id": "FADE_MODE",
      "byteOffset": 11,
      "byteLength": 1,
      "description": "Fade Mode",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0,
      "values": {
        "0": "ON-IN",
        "1": "ON-OUT",
        "2": "OFF-IN",
        "3": "OFF-OUT"
      }
    },
    "FADE": {
      "id": "FADE",
      "byteOffset": 12,
      "byteLength": 2,
      "description": "Fade Time",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "KEY_TRIG": {
      "id": "KEY_TRIG",
      "byteOffset": 14,
      "byteLength": 1,
      "description": "Key Trigger",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "PIT_DEPTH": {
      "id": "PIT_DEPTH",
      "byteOffset": 15,
      "byteLength": 1,
      "description": "Pitch Depth",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "TVF_DEPTH": {
      "id": "TVF_DEPTH",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "TVF Depth",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "TVA_DEPTH": {
      "id": "TVA_DEPTH",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "TVA Depth",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "PAN_DEPTH": {
      "id": "PAN_DEPTH",
      "byteOffset": 18,
      "byteLength": 1,
      "description": "PAN Depth",
      "dataRange": [
        -63,
        63
      ],
      "initValue": 0
    },
    "PHASE_POS": {
      "id": "PHASE_POS",
      "byteOffset": 19,
      "byteLength": 1,
      "description": "Phase Position",
      "dataRange": [
        0,
        3
      ],
      "initValue": 0
    },
    "STEP_1": {
      "id": "STEP_1",
      "byteOffset": 20,
      "byteLength": 1,
      "description": "Step 1",
      "dataRange": [
        -72,
        72
      ],
      "initValue": 0
    },
    "STEP_CURVE_1": {
      "id": "STEP_CURVE_1",
      "byteOffset": 36,
      "byteLength": 1,
      "description": "Step Curve 1",
      "dataRange": [
        0,
        36
      ],
      "initValue": 1
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PTL_LFO"] = {
  "name": "PTL_LFO",
  "description": "Partial LFO",
  "byteLength": 104,
  "parameters": {
    "LFO": {
      "id": "LFO",
      "byteOffset": 0,
      "byteLength": 104,
      "description": "LFO",
      "blockName": "PTL_LFO_LFO",
      "count": 2,
      "blockByteLength": 52,
      "block": ZenProperties["PTL_LFO_LFO"]
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PTL_PENV"] = {
  "name": "PTL_PENV",
  "description": "Partial Pitch Envelope",
  "byteLength": 24,
  "parameters": {
    "DEPTH": {
      "id": "DEPTH",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Pitch Env Depth",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "VSENS": {
      "id": "VSENS",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "Pitch Env Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "T1_VSENS": {
      "id": "T1_VSENS",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "Pitch Env T1 Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "T4_VSENS": {
      "id": "T4_VSENS",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "Pitch Env T4 Velocity Sens",
      "dataRange": [
        -100,
        100
      ],
      "initValue": 0
    },
    "T1": {
      "id": "T1",
      "byteOffset": 4,
      "byteLength": 2,
      "description": "Pitch Env Time1",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "T2": {
      "id": "T2",
      "byteOffset": 6,
      "byteLength": 2,
      "description": "Pitch Env Time2",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "T3": {
      "id": "T3",
      "byteOffset": 8,
      "byteLength": 2,
      "description": "Pitch Env Time3",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "T4": {
      "id": "T4",
      "byteOffset": 10,
      "byteLength": 2,
      "description": "Pitch Env Time4",
      "dataRange": [
        0,
        1023
      ],
      "initValue": 0
    },
    "L0": {
      "id": "L0",
      "byteOffset": 12,
      "byteLength": 2,
      "description": "Pitch Env Level0",
      "dataRange": [
        -511,
        511
      ],
      "initValue": 0
    },
    "L1": {
      "id": "L1",
      "byteOffset": 14,
      "byteLength": 2,
      "description": "Pitch Env Level1",
      "dataRange": [
        -511,
        511
      ],
      "initValue": 240
    },
    "L2": {
      "id": "L2",
      "byteOffset": 16,
      "byteLength": 2,
      "description": "Pitch Env Level2",
      "dataRange": [
        -511,
        511
      ],
      "initValue": 240
    },
    "L3": {
      "id": "L3",
      "byteOffset": 18,
      "byteLength": 2,
      "description": "Pitch Env Level3",
      "dataRange": [
        -511,
        511
      ],
      "initValue": 240
    },
    "L4": {
      "id": "L4",
      "byteOffset": 20,
      "byteLength": 2,
      "description": "Pitch Env Level4",
      "dataRange": [
        -511,
        511
      ],
      "initValue": 0
    },
    "VCRV": {
      "id": "VCRV",
      "byteOffset": 22,
      "byteLength": 1,
      "description": "Pitch Env Velocity Curve",
      "dataRange": [
        0,
        7
      ],
      "initValue": 1,
      "values": {
        "0": "FIXED",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7"
      }
    },
    "PADDING1": {
      "id": "PADDING1",
      "byteOffset": 23,
      "byteLength": 1,
      "description": "__padding",
      "dataRange": [
        0,
        0
      ],
      "initValue": null,
      "isPadding": true
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["RCMP"] = {
  "name": "RCMP",
  "description": "System RhythmComp",
  "byteLength": 8,
  "parameters": {
    "SW": {
      "id": "SW",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Comp Switch",
      "dataRange": [
        0,
        1
      ],
      "initValue": 0,
      "values": {
        "0": "OFF",
        "1": "ON"
      }
    },
    "ATTCK": {
      "id": "ATTCK",
      "byteOffset": 1,
      "byteLength": 1,
      "description": "Comp Attack Time",
      "dataRange": [
        0,
        100
      ],
      "initValue": 0,
      "displayMeasurement": "ms",
      "values": {
        "0": "0.1",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "6",
        "7": "7",
        "8": "8",
        "9": "9",
        "10": "10",
        "11": "11",
        "12": "12",
        "13": "13",
        "14": "14",
        "15": "15",
        "16": "16",
        "17": "17",
        "18": "18",
        "19": "19",
        "20": "20",
        "21": "21",
        "22": "22",
        "23": "23",
        "24": "24",
        "25": "25",
        "26": "26",
        "27": "27",
        "28": "28",
        "29": "29",
        "30": "30",
        "31": "31",
        "32": "32",
        "33": "33",
        "34": "34",
        "35": "35",
        "36": "36",
        "37": "37",
        "38": "38",
        "39": "39",
        "40": "40",
        "41": "41",
        "42": "42",
        "43": "43",
        "44": "44",
        "45": "45",
        "46": "46",
        "47": "47",
        "48": "48",
        "49": "49",
        "50": "50",
        "51": "51",
        "52": "52",
        "53": "53",
        "54": "54",
        "55": "55",
        "56": "56",
        "57": "57",
        "58": "58",
        "59": "59",
        "60": "60",
        "61": "61",
        "62": "62",
        "63": "63",
        "64": "64",
        "65": "65",
        "66": "66",
        "67": "67",
        "68": "68",
        "69": "69",
        "70": "70",
        "71": "71",
        "72": "72",
        "73": "73",
        "74": "74",
        "75": "75",
        "76": "76",
        "77": "77",
        "78": "78",
        "79": "79",
        "80": "80",
        "81": "81",
        "82": "82",
        "83": "83",
        "84": "84",
        "85": "85",
        "86": "86",
        "87": "87",
        "88": "88",
        "89": "89",
        "90": "90",
        "91": "91",
        "92": "92",
        "93": "93",
        "94": "94",
        "95": "95",
        "96": "96",
        "97": "97",
        "98": "98",
        "99": "99",
        "100": "100"
      }
    },
    "RELEASE": {
      "id": "RELEASE",
      "byteOffset": 2,
      "byteLength": 1,
      "description": "Comp Release Time",
      "dataRange": [
        0,
        99
      ],
      "initValue": 0,
      "displayMeasurement": "ms",
      "displayRange": [
        10,
        1000
      ]
    },
    "THRESHOLD": {
      "id": "THRESHOLD",
      "byteOffset": 3,
      "byteLength": 1,
      "description": "Comp Threshold",
      "dataRange": [
        -60,
        0
      ],
      "initValue": 0,
      "displayMeasurement": "dB"
    },
    "RATIO": {
      "id": "RATIO",
      "byteOffset": 4,
      "byteLength": 1,
      "description": "Comp Ratio",
      "dataRange": [
        0,
        7
      ],
      "initValue": 0,
      "values": {
        "0": "1:1",
        "1": "2:1",
        "2": "3:1",
        "3": "4:1",
        "4": "8:1",
        "5": "16:1",
        "6": "32:1",
        "7": "INF:1"
      }
    },
    "KNEE": {
      "id": "KNEE",
      "byteOffset": 5,
      "byteLength": 1,
      "description": "Comp Knee",
      "dataRange": [
        0,
        30
      ],
      "initValue": 0,
      "displayMeasurement": "dB"
    },
    "POSTGAIN": {
      "id": "POSTGAIN",
      "byteOffset": 6,
      "byteLength": 1,
      "description": "Comp Output Gain",
      "dataRange": [
        -48,
        48
      ],
      "initValue": 0,
      "displayMeasurement": "dB",
      "displayRange": [
        -24,
        24
      ]
    },
    "OUT_ASGN": {
      "id": "OUT_ASGN",
      "byteOffset": 7,
      "byteLength": 1,
      "description": "Comp Output Assign",
      "dataRange": [
        0,
        10
      ],
      "initValue": 1,
      "values": {
        "0": "DRY",
        "1": "MFX",
        "2": "MAIN",
        "3": "SUB1",
        "4": "SUB2",
        "5": "SUB3",
        "6": "SUB4",
        "7": "SUB5",
        "8": "SUB6",
        "9": "SUB7",
        "10": "SUB8"
      }
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["TONECOM"] = {
  "name": "TONECOM",
  "description": "ToneCom",
  "byteLength": 20,
  "parameters": {
    "NAME_1": {
      "id": "NAME_1",
      "byteOffset": 0,
      "byteLength": 1,
      "description": "Name 1",
      "dataRange": [
        32,
        127
      ],
      "initValue": 32,
      "displayMeasurement": "ASCII"
    },
    "CATEGORY": {
      "id": "CATEGORY",
      "byteOffset": 16,
      "byteLength": 1,
      "description": "Category",
      "dataRange": [
        0,
        50
      ],
      "initValue": 0,
      "values": {
        "0": "None",
        "1": "Ac.Piano",
        "2": "Pop-Piano",
        "3": "E.Grand Piano",
        "4": "E.Piano1",
        "5": "E.Piano2",
        "6": "E.Organ",
        "7": "Pipe Organ",
        "8": "Reed Organ",
        "9": "Harpsichord",
        "10": "Clav",
        "11": "Celesta",
        "12": "Accordion",
        "13": "Harmonica",
        "14": "Bell",
        "15": "Mallet",
        "16": "Ac.Guitar",
        "17": "E.Guitar",
        "18": "Dist.Guitar",
        "19": "Ac.Bass",
        "20": "E.Bass",
        "21": "Synth Bass",
        "22": "Plucked/Stroke",
        "23": "Solo Strings",
        "24": "Ensemble Strs",
        "25": "Orchestral",
        "26": "Solo Brass",
        "27": "Ensemble Brass",
        "28": "Wind",
        "29": "Flute",
        "30": "Sax",
        "31": "Recorder",
        "32": "Vox/Choir",
        "33": "Scat",
        "34": "Synth Lead",
        "35": "Synth Brass",
        "36": "Synth Pad/Str",
        "37": "Synth BellPad",
        "38": "Synth PolyKey",
        "39": "Synth FX",
        "40": "Synth Seq/Pop",
        "41": "Phrase",
        "42": "Pulsating",
        "43": "Beat&Groove",
        "44": "Hit",
        "45": "Sound FX",
        "46": "Drums",
        "47": "Percussion",
        "48": "Stack",
        "49": "Zone",
        "50": "Vocoder"
      }
    },
    "RSRV8": {
      "id": "RSRV8",
      "byteOffset": 17,
      "byteLength": 1,
      "description": "Reserved",
      "dataRange": [
        0,
        0
      ],
      "initValue": 0
    },
    "RSRV16": {
      "id": "RSRV16",
      "byteOffset": 18,
      "byteLength": 2,
      "description": "Reserved",
      "dataRange": [
        0,
        0
      ],
      "initValue": 0
    }
  },
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMEX"] = {
  "name": "PCMEX",
  "parameters": {
    "PCMT_CMN": {
      "blockName": "PCMT_CMN",
      "count": 1,
      "byteOffset": 0,
      "blockByteLength": 64,
      "byteLength": 64,
      "block": ZenProperties["PCMT_CMN"]
    },
    "MFX": {
      "blockName": "MFX",
      "count": 1,
      "byteOffset": 64,
      "blockByteLength": 84,
      "byteLength": 84,
      "block": ZenProperties["MFX"]
    },
    "PCMT_PMT": {
      "blockName": "PCMT_PMT",
      "count": 1,
      "byteOffset": 148,
      "blockByteLength": 52,
      "byteLength": 52,
      "block": ZenProperties["PCMT_PMT"]
    },
    "PCMT_PTL": {
      "blockName": "PCMT_PTL",
      "count": 4,
      "byteOffset": 200,
      "blockByteLength": 124,
      "byteLength": 496,
      "block": ZenProperties["PCMT_PTL"]
    },
    "PTL_PENV": {
      "blockName": "PTL_PENV",
      "count": 4,
      "byteOffset": 696,
      "blockByteLength": 24,
      "byteLength": 96,
      "block": ZenProperties["PTL_PENV"]
    },
    "PTL_FENV": {
      "blockName": "PTL_FENV",
      "count": 4,
      "byteOffset": 792,
      "blockByteLength": 24,
      "byteLength": 96,
      "block": ZenProperties["PTL_FENV"]
    },
    "PTL_AENV": {
      "blockName": "PTL_AENV",
      "count": 4,
      "byteOffset": 888,
      "blockByteLength": 16,
      "byteLength": 64,
      "block": ZenProperties["PTL_AENV"]
    },
    "PTL_LFO": {
      "blockName": "PTL_LFO",
      "count": 4,
      "byteOffset": 952,
      "blockByteLength": 104,
      "byteLength": 416,
      "block": ZenProperties["PTL_LFO"]
    },
    "PTL_EQ": {
      "blockName": "PTL_EQ",
      "count": 4,
      "byteOffset": 1368,
      "blockByteLength": 16,
      "byteLength": 64,
      "block": ZenProperties["PTL_EQ"]
    },
    "PCMS_CMN": {
      "blockName": "PCMS_CMN",
      "count": 1,
      "byteOffset": 1432,
      "blockByteLength": 20,
      "byteLength": 20,
      "block": ZenProperties["PCMS_CMN"]
    },
    "PCMS_PMT": {
      "blockName": "PCMS_PMT",
      "count": 1,
      "byteOffset": 1452,
      "blockByteLength": 36,
      "byteLength": 36,
      "block": ZenProperties["PCMS_PMT"]
    },
    "PCMS_PTL": {
      "blockName": "PCMS_PTL",
      "count": 4,
      "byteOffset": 1488,
      "blockByteLength": 36,
      "byteLength": 144,
      "block": ZenProperties["PCMS_PTL"]
    }
  },
  "byteLength": 1632,
  "category": "Autogenerated: jupiter"
};

ZenProperties["PCMR"] = {
  "name": "PCMR",
  "parameters": {
    "PCMR_CMN": {
      "blockName": "PCMR_CMN",
      "count": 1,
      "byteOffset": 0,
      "blockByteLength": 28,
      "byteLength": 28,
      "block": ZenProperties["PCMR_CMN"]
    },
    "MFX": {
      "blockName": "MFX",
      "count": 1,
      "byteOffset": 28,
      "blockByteLength": 84,
      "byteLength": 84,
      "block": ZenProperties["MFX"]
    },
    "RCMP": {
      "blockName": "RCMP",
      "count": 6,
      "byteOffset": 112,
      "blockByteLength": 8,
      "byteLength": 48,
      "block": ZenProperties["RCMP"]
    },
    "PCMR_PTL": {
      "blockName": "PCMR_PTL",
      "count": 88,
      "byteOffset": 160,
      "blockByteLength": 20,
      "byteLength": 1760,
      "block": ZenProperties["PCMR_PTL"]
    },
    "PTL_EQ": {
      "blockName": "PTL_EQ",
      "count": 88,
      "byteOffset": 1920,
      "blockByteLength": 16,
      "byteLength": 1408,
      "block": ZenProperties["PTL_EQ"]
    }
  },
  "byteLength": 3328,
  "category": "Autogenerated: jupiter"
};

ZenProperties["MdlSynPrm0"] = {
  "name": "MdlSynPrm0",
  "parameters": {
    "MDLSYN0": {
      "blockName": "MDLSYN0",
      "count": 1,
      "byteOffset": 0,
      "blockByteLength": 112,
      "byteLength": 112,
      "block": ZenProperties["MDLSYN0"]
    },
    "MFX": {
      "blockName": "MFX",
      "count": 1,
      "byteOffset": 112,
      "blockByteLength": 84,
      "byteLength": 84,
      "block": ZenProperties["MFX"]
    },
    "TONECOM": {
      "blockName": "TONECOM",
      "count": 1,
      "byteOffset": 196,
      "blockByteLength": 20,
      "byteLength": 20,
      "block": ZenProperties["TONECOM"]
    }
  },
  "byteLength": 216,
  "category": "Autogenerated: jupiter"
};

ZenProperties["MdlJD800"] = {
  "name": "MdlJD800",
  "parameters": {
    "MDLJD800COM": {
      "blockName": "MDLJD800COM",
      "count": 1,
      "byteOffset": 0,
      "blockByteLength": 44,
      "byteLength": 44,
      "block": ZenProperties["MDLJD800COM"]
    },
    "MDLJD800PTL": {
      "blockName": "MDLJD800PTL",
      "count": 4,
      "byteOffset": 44,
      "blockByteLength": 80,
      "byteLength": 320,
      "block": ZenProperties["MDLJD800PTL"]
    },
    "MFX": {
      "blockName": "MFX",
      "count": 1,
      "byteOffset": 364,
      "blockByteLength": 84,
      "byteLength": 84,
      "block": ZenProperties["MFX"]
    },
    "MDLJD800FxB": {
      "blockName": "MDLJD800FxB",
      "count": 1,
      "byteOffset": 448,
      "blockByteLength": 32,
      "byteLength": 32,
      "block": ZenProperties["MDLJD800FxB"]
    },
    "TONECOM": {
      "blockName": "TONECOM",
      "count": 1,
      "byteOffset": 480,
      "blockByteLength": 20,
      "byteLength": 20,
      "block": ZenProperties["TONECOM"]
    }
  },
  "byteLength": 500,
  "category": "Autogenerated: jupiter"
};

ZenProperties["VoDsgn"] = {
  "name": "VoDsgn",
  "parameters": {
    "MDLVDN": {
      "blockName": "MDLVDN",
      "count": 1,
      "byteOffset": 0,
      "blockByteLength": 32,
      "byteLength": 32,
      "block": ZenProperties["MDLVDN"]
    },
    "TONECOM": {
      "blockName": "TONECOM",
      "count": 1,
      "byteOffset": 32,
      "blockByteLength": 20,
      "byteLength": 20,
      "block": ZenProperties["TONECOM"]
    },
    "MFX": {
      "blockName": "MFX",
      "count": 1,
      "byteOffset": 52,
      "blockByteLength": 84,
      "byteLength": 84,
      "block": ZenProperties["MFX"]
    }
  },
  "byteLength": 136,
  "category": "Autogenerated: jupiter"
};

export default ZenProperties;
